export const guaraniTranslations: Record<string, string> = {
  "Abog. Rodolfo Enmanuel Gini Orue": "Abog. Rodolfo Enmanuel Gini Orue",
  "patente comercial": "ñemuhára patente",
  "Saltar al contenido": "Ehasa marandu rendápe",
  "Idioma del portal": "Tavão rokẽ ñe'ẽ",
  "República del Paraguay · Gobierno Municipal": "Paraguái Retã · Tavao Rekuái",
  Accesibilidad: "Jeikeporã opavavépe",
  "Abrir herramientas de accesibilidad": "Eipe'a jeikeporã tembiporukuéra",
  "Cerrar herramientas de accesibilidad": "Emboty jeikeporã tembiporukuéra",
  "Herramientas de accesibilidad": "Jeikeporã tembiporukuéra",
  "Ajustá la visualización del portal": "Emohenda mba'éichapa ojehecha tavão rokẽ",
  "Aumentar texto": "Embotuichave ñe'ẽ",
  "Disminuir texto": "Emomichĩve ñe'ẽ",
  "Escala de grises": "Sa'y hũngy",
  "Alto contraste": "Joavy hesakãva",
  "Contraste negativo": "Joavy iñambuéva",
  "Fondo claro": "Tugua hesakãva",
  "Enlaces subrayados": "Joajuhakuéra guýpe línea",
  "Fuente legible": "Tai oñemoñe'ẽ porãva",
  "Reducir movimiento": "Emomichĩ ñemýi",
  Reiniciar: "Emoñepyrũ jey",
  Español: "Castellano",
  "Activar modo claro": "Eiporu jehecha hesakãva",
  "Activar modo oscuro": "Eiporu jehecha pytũva",
  "Abrir menú": "Eipe'a poravorã",
  "Cerrar menú": "Emboty poravorã",
  "Navegación principal": "Jeikeha tenondegua",
  Inicio: "Ñepyrũ",
  Trámites: "Tembiaporã",
  Institución: "Tavao",
  Intendencia: "Tavao Mburuvichaha",
  Transparencia: "Tesakã",
  "Información pública": "Marandu opavavépe g̃uarã",
  "Leyes y reglamentos": "Léi ha mbojojahakuéra",
  "Más información": "Marandu hetave",
  Obras: "Tembiapo",
  "Cultura y turismo": "Arandupy ha jeheguata",
  Noticias: "Marandu",
  Movilidad: "Jeguatapy",
  Academia: "Mbo'ehao",
  Contacto: "Ñe'ẽha",
  Buscar: "Heka",
  Ingresar: "Eike",
  "Ir a mi espacio": "Tereho nde rendápe",
  "Ingresar a mi espacio": "Eike nde rendápe",
  "Continuar al panel personal": "Eho tenonde nde panel-pe",
  "Trámites, documentos y seguimiento": "Tembiaporã, kuatiakuéra ha jehechajey",
  "Sesión protegida": "Jeikeha oñeñangarekóva",
  "¿Seguís en línea?": "Reimépa gueteri línea-pe?",
  "Por seguridad, tu sesión se cerrará en": "Tekorosã rehe, ne rembiapo oñembotýta",
  "segundos por inactividad.": "aravo'i rire nereñemýigui.",
  "Cerrar sesión ahora": "Emboty jeikeha ko'ág̃a",
  "Sí, sigo en línea": "Héẽ, aime gueteri línea-pe",
  "La sesión se cerró después de 5 minutos de inactividad.":
    "Jeikeha oñemboty 5 aravo'i nereñemýi rire.",
  "Gobierno Municipal de Piribebuy": "Piribebuy Tavao Rekuái",
  "Servicios e información para la ciudadanía": "Tavayguárape tembiaporã ha marandu",
  "Nuestra ciudad, más cerca de vos.": "Ñane táva, hi'ag̃uive ndehegui.",
  "Información, servicios y participación ciudadana en un solo lugar.":
    "Marandu, tembiaporã ha tavaygua ñepytyvõ peteĩ hendápente.",
  "Información, servicios y atención municipal en un solo lugar":
    "Tavao marandu, tembiaporã ha ñangareko peteĩ hendápente",
  Atención: "Ñangareko",
  "Lun. a vie., 07:00 a 13:00": "Arakõi guive arapoteĩ meve, 07:00 guive 13:00 peve",
  "Enlaces institucionales": "Tavao joajuha",
  Municipalidad: "Tavao",
  "Estado de servicios": "Tembiaporã reko",
  "Uso responsable": "Jeporu hekopete",
  Privacidad: "Ñemigua ñangareko",
  "Términos de uso": "Jeporu mbojojaha",
  "Información del proyecto": "Tembiapo rehegua marandu",
  "Desarrollado por Arandu Dev.": "Arandu Dev ojapo.",
  "Nuestra ciudad, más cerca de vos": "Ñane táva, hi'ag̃uive ndehegui",
  "Un espacio para mantenerte informado, conocer los servicios municipales y acceder a herramientas que facilitan tu día a día. Trabajamos para acercar la información a cada barrio, compañía y comunidad de Piribebuy.":
    "Ko tendápe reikuaáta tavão marandu ha tembiaporã, ha reiporúta tembiporu ne rembiapo ára ha ára ombovevýiva. Romoguahẽse marandu opaite Piribebuy tava'i, compañía ha tekoha peve.",
  "¿Qué necesitás hacer?": "Mba'épa reikotevẽ rejapo?",
  "Ej.: presentar una nota o consultar requisitos":
    "Techapyrã: emoinge kuatia térã ehecha mba'épa oñeikotevẽ",
  "Iniciar solicitud": "Eñepyrũ jerure",
  "Ver todos los trámites": "Ehecha opa tembiaporã",
  "Piribebuy, ciudad histórica": "Piribebuy, táva rembiasakue",
  "Historia, naturaleza y comunidad": "Tembiasakue, tekoha ha tekove aty",
  "El portal de nuestra ciudad": "Ñane táva rokẽ digitaal",
  Foto: "Ta'anga",
  "Encontrar un trámite": "Eheka tembiaporã",
  "Requisitos, costos, plazos y modalidades.":
    "Oñeikotevẽva, hepykue, aravo ha mba'éichapa ojejapo.",
  "Presentar una nota": "Emoinge kuatia",
  "Iniciá y seguí una solicitud municipal.":
    "Eñepyrũ ha ehecha mba'éichapa oho ne jerure tavãope.",
  "Información pública organizada y fechada.":
    "Marandu opavavépe g̃uarã, oñemohenda ha oñemboára porãva.",
  "Pagos municipales": "Tavao jehepyme'ẽ",
  "Consultá obligaciones, comprobantes y recibos.":
    "Ehecha nde jehepyme'ẽrã, kuatiarechaukaha ha recibo.",
  "Movilidad y servicios": "Jeguatapy ha tembiaporã",
  "Movete mejor por Piribebuy": "Eguata porãve Piribebuy rupi",
  "Consultá recorridos, conocé las opciones de transporte disponibles y encontrá información útil para organizar tus desplazamientos.":
    "Ehecha tape, mba'yrumýi ojeporukuaáva ha marandu nde jeguata remohenda hag̃ua.",
  "Conocer el módulo": "Eikuaa ko vore",
  "Transporte público": "Mba'yrumýi opavavépe g̃uarã",
  "¿Dónde está mi colectivo?": "Moõpa oĩ che kolektívo?",
  "Ubicación, próxima parada, distancia y llegada estimada.":
    "Moõpa oĩ, pytaha oúva, mombyrykue ha araka'épa og̃uahẽta.",
  "Servicio municipal": "Tavao rembiaporã",
  "¿Dónde está el recolector?": "Moõpa oĩ mba'e ky'a mono'õha?",
  "Zonas atendidas, progreso y estimación para tu ubicación.":
    "Tenda oñeñangarekóva, mba'éichapa oho ha araka'épa og̃uahẽta nde rendápe.",
  "Los recorridos y horarios se muestran según la información operativa disponible.":
    "Tape ha aravo ojehechauka marandu ojeguerekóva rupive.",
  "Territorio municipal": "Tavao yvy",
  "Explorá el mapa catastral de Piribebuy": "Ehecha Piribebuy yvy ra'anga",
  "Consultá parcelas, áreas urbanas y el límite distrital con geometrías públicas del Servicio Nacional de Catastro. La información es referencial y no muestra datos personales.":
    "Ehecha yvy pehẽngue, táva ryepypegua ha distrito rembe'y Catastro Nacional marandu rupive. Ko marandu jehechaukaha año ha ndohechaukái tapicha marandu ñemigua.",
  "Abrir mapa": "Eipe'a yvy ra'anga",
  "Servicios ciudadanos": "Tavaygua rembiaporã",
  "Los servicios de tu ciudad, en un solo lugar":
    "Nde táva rembiaporã peteĩ hendápente",
  "Encontrá información útil, consultá servicios disponibles y accedé a las herramientas municipales de manera sencilla y organizada.":
    "Ejuhu marandu iporãva, ehecha tembiaporã ojeguerekóva ha eiporu tavão rembiporu hasy'ỹ ha oñemohenda porãva.",
  "Ver catálogo completo": "Ehecha tembiaporã ryru tuichakue",
  "Disponible en línea": "Ojeporukuaa internet rupive",
  "En revisión": "Ojehechajeyhína",
  Información: "Marandu",
  Modalidad: "Mba'éichapa ojejapo",
  Plazo: "Aravo",
  "Consultar ficha": "Ehecha marandu",
  "Conocé nuestro gobierno municipal": "Eikuaa ñande tavão rekuái",
  "Accedé a información sobre las autoridades, la organización institucional y las áreas de trabajo del municipio.":
    "Ehecha mburuvicha, tavão ñemohenda ha mba'apo renda rehegua marandu.",
  "Documentos de transparencia": "Tesakã kuatiakuéra",
  "Seguimiento de obras": "Tembiapo rapykueho",
  "Dependencias y atención": "Tavao vore ha ñangareko",
  "Servicios digitales": "Tembiaporã digitaal",
  "Disponibilidad actual": "Ojeporukuaáva ko'ág̃a",
  "Portal público": "Opavavépe g̃uarã rokẽ",
  "Mesa de Entrada": "Kuatia ñemoguahẽha",
  Notificaciones: "Marandu pyahu",
  Disponible: "Ojeporukuaa",
  "No disponible": "Ndojeporukuaái",
  "Ver detalle e incidentes": "Ehecha marandu ha apañuãi",
  "Participación ciudadana": "Tavaygua ñepytyvõ",
  "Tu participación hace la diferencia": "Nde ñepytyvõ tuicha mba'e",
  "Cada consulta, sugerencia y reporte contribuye a identificar las necesidades de nuestra comunidad. Queremos facilitar la comunicación entre la ciudadanía y el gobierno municipal.":
    "Opa porandu, ñe'ẽporã ha marandu ñanepytyvõ jaikuaa hag̃ua ñande tekoha oikotevẽva. Rombohasy'ỹse tavaygua ha tavão rekuái ñomongeta.",
  "Presentar una solicitud": "Emoinge jerure",
  "Ver canales de atención": "Ehecha ñangareko rape",
  "Actualidad municipal": "Tavao marandu ko'ag̃agua",
  "Piribebuy al día": "Piribebuy marandu pyahu",
  "Todas las noticias": "Opa marandu",
  "Noticia institucional": "Tavao marandu",
  "Leer noticia": "Emoñe'ẽ marandu",
  "Sin publicaciones disponibles": "Ndaipóri marandu ojehechaukáva",
  "Las noticias aparecerán aquí cuando hayan sido publicadas por el equipo responsable.":
    "Marandukuéra ojekuaaukáta ko'ápe aty omba'apóva omoherakuã vove.",
  "Abrir noticias": "Eipe'a marandukuéra",
  "Historia e identidad": "Tembiasakue ha teko tee",
  "Piribebuy: memoria, tejido y naturaleza cordillerana":
    "Piribebuy: mandu'a, ñanduti ha Cordillera rekoha",
  "Conocer cultura y turismo": "Eikuaa arandupy ha jeheguata",
  "Conocer la Municipalidad": "Eikuaa Tavao",
  "Obras públicas": "Opavavépe g̃uarã tembiapo",
  "Seguimiento claro del avance": "Tembiapo rapykueho hesakãva",
  "Presupuesto, fuente, ubicación, documentos y avance publicado.":
    "Virurã, moõguipa ou, tenda, kuatiakuéra ha mba'éichapa oho.",
  "Ver todas las obras": "Ehecha opa tembiapo",
  Avance: "Mba'éichapa oho",
  "Ver ficha de la obra": "Ehecha tembiapo marandu",
  "Portal ciudadano": "Tavaygua rokẽ",
  "Buscar en el portal municipal": "Eheka tavão rokẽme",
  "Encontrá trámites, dependencias, noticias, obras, lugares y servicios municipales desde un solo lugar.":
    "Ejuhu tembiaporã, tavão vore, marandu, obra, tenda ha tavão rembiaporã peteĩ hendápente.",
  "¿Qué necesitás encontrar?": "Mba'épa reikotevẽ rejuhu?",
  "Ej.: patente comercial, museo o recolección":
    "Techapyrã: patente comercial, museo térã ñemono'õ",
  "Búsquedas frecuentes": "Ojehekavéva",
  Resultados: "Ojejuhúva",
  "No encontramos coincidencias": "Ndorojuhúi ojokupytýva",
  "Probá con una palabra más general, revisá la escritura o consultá el catálogo de trámites.":
    "Eiporu ambue ñe'ẽ, ehechajey ijehai térã ehecha tembiaporã ryru.",
  "Ver trámites": "Ehecha tembiaporã",
  Trámite: "Tembiaporã",
  Noticia: "Marandu",
  Obra: "Tembiapo",
  Lugar: "Tenda",
  Dependencia: "Tavao vore",
  Sección: "Vore",
  Todo: "Opavave",
  "Error 404": "Jejavy 404",
  "No encontramos esta página": "Ndorojuhúi ko togue",
  "El enlace puede estar desactualizado. Buscá el contenido o elegí uno de los accesos principales.":
    "Ko joajuha ikatu itujáma. Eheka marandu térã eiporavo jeikeha tenondegua.",
  "Trámite, servicio, noticia o dependencia": "Tembiaporã, marandu térã tavão vore",
  "Contactar a la Municipalidad": "Eñe'ẽ Tavao ndive",
  Cargando: "Oñemyenyhẽhína",
  "Preparando pantalla": "Oñembosako'ihína jehechaha",
  "No pudimos completar la acción": "Ndaikatúi romohu'ã ko tembiapo",
  "Mi espacio": "Che renda",
  "Mis trámites": "Che rembiaporã",
  "Nueva solicitud": "Jerure pyahu",
  "Mis pagos": "Che jehepyme'ẽ",
  "Mi aprendizaje": "Che ñemoarandu",
  Gestión: "Ñangareko",
  "Gestión académica": "Mbo'ehao ñangareko",
  "Organización y accesos": "Ñemohenda ha jeike",
  Guardar: "Eñongatu",
  Cancelar: "Heja",
  Continuar: "Eho tenonde",
  Volver: "Ejevy",
  Cerrar: "Emboty",
  Abrir: "Eipe'a",
  Enviar: "Emondo",
  Editar: "Embosako'i",
  Eliminar: "Embogue",
  Confirmar: "Emoneĩ",
  Nombre: "Téra",
  Apellido: "Terajoapy",
  Correo: "Ñe'ẽveve",
  Teléfono: "Pumbyry",
  Dirección: "Tenda",
  Fecha: "Arange",
  Categoría: "Mba'e aty",
  Descripción: "Mombe'u",
  Documentos: "Kuatiakuéra",
  Requisitos: "Oñeikotevẽva",
  Costo: "Hepykue",
  Estado: "Teko",
  Responsable: "Omba'apóva hese",
  "Última actualización": "Oñembopyahu hague",
  Catastro: "Yvy marandu",
  "Accesibilidad digital": "Jeikeporã digitaal opavavépe",
  "Servicios que puedan ser utilizados por más personas":
    "Tembiaporã hetave tapicha oiporukuaáva",
  "El portal incorpora criterios de accesibilidad para facilitar la navegación, la lectura y el uso de sus servicios.":
    "Tavão rokẽ oguereko jeikeporã rape, oñembovevúi hag̃ua jeheka, moñe'ẽ ha tembiaporã jeporu.",
  "Funciones disponibles": "Tembiaporã ojeporukuaáva",
  "Navegación por teclado y enlace para saltar al contenido.":
    "Jeheka tecládo rupive ha joajuha marandu rendápe ojehasa hag̃ua.",
  "Foco visible en controles.": "Jehechauka hesakãva umi control-pe.",
  "Jerarquía de encabezados y formularios con etiquetas.":
    "Moakãha oñemohenda porã ha formulario herakuéra ndive.",
  "Estados acompañados por texto, no solo color.":
    "Teko ojehechauka ñe'ẽme avei, ndaha'éi sa'ýpe añónte.",
  "Diseño adaptable, zoom y áreas táctiles cómodas.":
    "Ta'anga iñambuéva pantalla rehe, zoom ha jepokoha porã.",
  "Preferencia de movimiento reducido.": "Ñemýi mbovyve ojeporavokuaa.",
  "Mensajes dinámicos anunciados a tecnologías de asistencia.":
    "Marandu iñambuéva oñemomarandu pytyvõha tecnología-pe.",
  "Preferencias visuales guardadas en este dispositivo.":
    "Jehecha poravorã oñeñongatu ko tembiporúpe.",
  "Foto tipo carné": "Karnéichagua ta'anga",
  "Descripción de la foto": "Ta'anga ñemombe'u",
  "Descripción de la foto en avañe’ẽ": "Ta'anga ñemombe'u avañe'ẽme",
  "Foto publicada actualmente": "Ta'anga ko'ág̃a ojehechaukáva",
  "Tamaño de texto:": "Ñe'ẽ tuichakue:",
  "por ciento.": "sa apytégui.",
  "JPG, PNG o WebP, hasta 10 MB. Se recorta visualmente a formato cuadrado; conviene usar un retrato vertical y centrado.":
    "JPG, PNG térã WebP, 10 MB peve. Ojehechaukáta karrádoramo; iporãve ta'anga yvate ha mbytepeguáva.",
  "Retrato institucional de Nombre Apellido": "Nombre Apellido ra'anga tavaopegua",
  Idioma: "Ñe'ẽ",
  "El contenido y los controles principales del portal están disponibles en español y avañe’ẽ. Los nombres propios y los textos administrativos que requieren validación conservan su redacción original.":
    "Tavão rokẽ marandu ha control tenondegua ojeporukuaa castellano ha avañe'ẽme. Tapicha réra ha kuatia tavão rehegua oikotevẽva jehechajey opyta ijehai ypykuépe.",
  "¿Encontraste una barrera?": "Rejuhúpa peteĩ apañuãi?",
  "Utilizá Mesa de Entrada y describí la página, el control y la tecnología de asistencia utilizada.":
    "Eiporu Kuatia Ñemoguahẽha ha emombe'u togue, control ha pytyvõha tecnología reiporuva'ekue.",
  "Reportar barrera": "Emomarandu apañuãi",
  "Documentos vigentes": "Kuatiakuéra oikovéva",
  Documento: "Kuatia",
  Periodo: "Arange pukukue",
  Publicación: "Ñemyasãi",
  Formato: "Ysaja",
  Vigencia: "Tekove",
  "Obra pública": "Tembiapo opavavépe g̃uarã",
  "Seguimiento municipal": "Tavao rapykueho",
  Ubicación: "Tenda",
  Presupuesto: "Virurã",
  Fuente: "Moõguipa ou",
  Contratista: "Tembiapo ojapóva",
  "Fin estimado": "Arange oñeimo'ãva opataha",
  "Avance informado": "Tembiapo ojeikuaaukáva",
  "Cultura e identidad de Piribebuy": "Piribebuy arandupy ha teko tee",
  "Una invitación local": "Ñane táva ñepepirũ",
  "Historia que se encuentra caminando": "Tembiasakue jajuhúva jaguatávo",
  "Antes de tu visita": "Reho mboyve",
  "Leer detalle": "Emoñe'ẽ marandu tuichakue",
  "Atención en Piribebuy": "Ñangareko Piribebuy-pe",
  Horario: "Aravo",
  "Lunes a viernes, 07:00 a 13:00":
    "Arakõi guive arapoteĩ meve, 07:00 guive 13:00 peve",
  "Directorio de dependencias": "Tavao vore ryru",
  "Canal formal de consultas": "Porandu rape tee",
  "Las solicitudes formales se reciben por Mesa de Entrada Digital.":
    "Jerure tee oñemog̃uahẽ Kuatia Ñemoguahẽha Digitaal rupive.",
  "Mesa de Entrada Digital": "Kuatia Ñemoguahẽha Digitaal",
  "Ir a Mesa de Entrada": "Tereho Kuatia Ñemoguahẽhápe",
  "Información actualizada al abrir esta página.":
    "Marandu oñembopyahu ko togue ojepe'ávo.",
  "Sin incidentes informados": "Ndaipóri apañuãi ojeikuaaukáva",
  "Gobierno municipal": "Tavao rekuái",
  "Secciones de la institución": "Tavao vorekuéra",
  "Intendente Municipal": "Tavao ruvicha",
  "Órgano deliberativo": "Aty oñomongetáva",
  "Junta Municipal": "Tavao Aty",
  "Marco normativo": "Mbojojahakuéra renda",
  "Ordenanzas, resoluciones, decretos y reglamentos publicados por la Municipalidad.":
    "Ordenanza, resolución, decreto ha mbojojahakuéra Tavao omyasãiva.",
  "Integración proclamada para el periodo municipal 2026–2031.":
    "Aty oñemoañetéva tavão arange 2026–2031-pe g̃uarã.",
  "Funciones generales": "Tembiapo tenondegua",
  "Información oficial": "Marandu tee",
  "Secretaría General": "Secretaría General",
  Administración: "Ñangarekoha",
  "Servicios municipales": "Tavao rembiaporã",
  "Buscar trámites": "Eheka tembiaporã",
  "Todas las modalidades": "Opa mba'éichapa ojejapo",
  Online: "Internet rupive",
  Presencial: "Tovake",
  Mixta: "Oñondivepa",
  "Todos los costos": "Opa hepykue",
  Gratuito: "Reiete",
  Variable: "Iñambuéva",
  "Con tasa": "Tása reheve",
  "Tiempo estimado": "Aravo oñeimo'ãva",
  Cuenta: "Cuenta",
  "Volver al catálogo": "Ejevy tembiaporã ryrupe",
  "Información en revisión": "Marandu ojehechajeyhína",
  "¿Para quién es?": "Mávape g̃uarãpa?",
  "Requisitos y documentación": "Oñeikotevẽva ha kuatiakuéra",
  Pasos: "Jeguatarã",
  "Base normativa": "Mbojojaha ypy",
  "Preguntas frecuentes": "Porandu ojejapovéva",
  "Datos principales": "Marandu tenondegua",
  "Plazo orientativo": "Aravo jehechaukaha",
  Ayuda: "Pytyvõ",
  "Responsabilidad de la ficha": "Ko marandu rehe ñangareko",
  "Última revisión:": "Jehechajey paha:",
  "Responsable:": "Omba'apóva hese:",
  "Portal seguro": "Rokẽ hekorosãva",
  "Ingresar al Gobierno Municipal": "Eike Tavao Rekuáipe",
  Contraseña: "Ñe'ẽñemi",
  "¿Olvidaste tu contraseña?": "Nderesaráipa ne ñe'ẽñemi?",
  "Crear cuenta ciudadana": "Ejapo tavaygua cuenta",
  "Acceso protegido": "Jeike oñeñangarekóva",
  "Acceso institucional": "Tavao jeike",
  "La sesión se cierra después de 5 minutos de inactividad.":
    "Nde jeike oñemboty 5 aravo'i rire ndereipurúiramo.",
  "Cuenta ciudadana": "Tavaygua cuenta",
  "Crear una cuenta": "Ejapo peteĩ cuenta",
  "Usá un correo al que tengas acceso para confirmar tu identidad.":
    "Eiporu ñe'ẽveve reikeha ikatuhápe remoañete hag̃ua nde rekotee.",
  "Nombre completo": "Téra ha terajoapy",
  "Recuperación segura": "Jeike jeguerujey hekorosãva",
  "Recuperar acceso": "Eguerujey nde jeike",
  "La respuesta no confirma si una cuenta existe.":
    "Mbohovái nomoañetéi oĩpa peteĩ cuenta.",
  "Elegí una contraseña nueva": "Eiporavo ñe'ẽñemi pyahu",
  "Nueva contraseña": "Ñe'ẽñemi pyahu",
  "Seguí tus presentaciones y respondé observaciones.":
    "Ehapykueho ne kuatiakuéra ha embohovái ojehaíva.",
  "Información en vivo": "Marandu ko'ag̃agua",
  "Ver ruta y próxima parada": "Ehecha tape ha pytaha oúva",
  "Consultar el recorrido de hoy": "Ehecha ko ára rape",
  "Últimas solicitudes": "Jerure ipyahuvéva",
  "Ordenadas por actualización.": "Oñemohenda oñembopyahu hague rupi.",
  "Solo vos podés consultar estas presentaciones.":
    "Nde añoite ikatu rehecha ko'ã kuatiakuéra.",
  "Todos los estados": "Opa teko",
  "Crear solicitud": "Ejapo jerure",
  Número: "Papapy",
  Asunto: "Mba'e rehegua",
  Actualización: "Ñembopyahu",
  Acción: "Tembiapo",
  "Presentación de nota o solicitud general": "Kuatia térã jerure jepresenta",
  "Completá la información, revisá los datos y presentá.":
    "Emyenyhẽ marandu, ehechajey ha emoinge.",
  "Datos de la persona solicitante": "Ojeruréva marandu",
  "Tipo de solicitante": "Ojerurévaichagua",
  Persona: "Tapicha",
  Organización: "Aty",
  "Documento de identidad": "Kuatiatee",
  "Contenido de la solicitud": "Jerure marandu",
  "Atención ciudadana": "Tavaygua ñangareko",
  "Servicios urbanos": "Táva rembiaporã",
  Comercio: "Ñemuhã",
  Otro: "Ambue",
  "Dependencia sugerida": "Tavao vore oñeimo'ãva",
  "Dirección relacionada (opcional)": "Tenda rehegua (reipotáramo)",
  "Documentos adjuntos": "Kuatiakuéra joapýva",
  "Protegé tus datos": "Eñangareko nde marandu rehe",
  "Elegir archivos": "Eiporavo marandurenda",
  "Vista previa y presentación": "Jehecha mboyve ha ñemoguahẽ",
  Solicitante: "Ojeruréva",
  Respuesta: "Mbohovái",
  "Datos de la presentación": "Kuatia ñemoguahẽ marandu",
  "Dependencia actual": "Tavao vore ko'ag̃agua",
  "Fecha de ingreso": "Arange oike hague",
  "Línea de tiempo": "Arange rape",
  "¿Necesitás ayuda?": "Reikotevẽpa pytyvõ?",
  "Situación general del municipio": "Tavao reko tuichakue",
  "Indicadores consolidados de atención, recaudación y servicios.":
    "Ñangareko, viru ñembyaty ha tembiaporã rechaukaha oñondive.",
  "Atención prioritaria": "Ñangareko tenondegua",
  Expedientes: "Kuatiaryru",
  "Entradas y resoluciones": "Jeike ha ñemohu'ã",
  Dependencias: "Tavao vorekuéra",
  "Carga pendiente": "Tembiapo opytáva",
  Portal: "Rokẽ",
  "Páginas más consultadas": "Togue ojehechavéva",
  Tesorería: "Viru ñangarekoha",
  "Estado de cobros": "Jehepyme'ẽ ñembyaty reko",
  "Saldo pendiente": "Viru opytáva",
  "Pagos verificados": "Jehepyme'ẽ oñemoañetéva",
  "Por verificar": "Oñemoañeteva'erã",
  "Obras en ejecución": "Tembiapo ojejapohína",
  "Obras planificadas": "Tembiapo oñembosako'íva",
  "Vehículos conectados": "Mba'yrumýi joajupyre",
  "Noticias publicadas": "Marandu oñemyasãiva",
  "Documentos públicos": "Kuatiakuéra opavavépe g̃uarã",
  "Usuarios registrados": "Oiporúva oñemboheraguapýva",
  "Academia municipal": "Tavao mbo'ehao",
  "Acceso a información": "Marandu jeike",
  "Acceso institucional seguro. Nunca compartas tu contraseña ni códigos de recuperación.":
    "Tavao jeike hekorosãva. Ani emombe'u avavépe ne ñe'ẽñemi térã jeike jeguerujey papapy.",
  "Acción social": "Tekoa pytyvõ",
  "Acerca del portal": "Tavão rokẽ rehegua",
  "Actualizar contraseña": "Embopyahu ñe'ẽñemi",
  "Antes de iniciar, confirmá los requisitos, el costo y la dependencia responsable por los canales de atención.":
    "Eñepyrũ mboyve, emoañete oñeikotevẽva, hepykue ha tavão vore omba'apóva hese ñangareko rape rupive.",
  "Atención digital y presencial": "Ñangareko digitaal ha tovake",
  "Autoridades, Junta Municipal, dependencias y horarios.":
    "Mburuvichakuéra, Tavao Aty, tavão vorekuéra ha aravo.",
  "Buscá por necesidad y conocé requisitos, costo, modalidad, plazo y dependencia responsable.":
    "Eheka reikotevẽva ha eikuaa mba'épa oñeikotevẽ, hepykue, mba'éichapa ojejapo, aravo ha tavão vore omba'apóva hese.",
  "Buscar documento, periodo o dependencia":
    "Eheka kuatia, arange pukukue térã tavão vore",
  "Buscar noticias": "Eheka marandu",
  "Buscar por palabra o dependencia": "Eheka ñe'ẽ térã tavão vore rupive",
  "Cada persona puede consultar la información pública sin iniciar sesión. Los datos personales se solicitan solamente cuando son necesarios para prestar un servicio o dar seguimiento a una solicitud.":
    "Opa tapicha ikatu ohecha marandu opavavépe g̃uarã oike'ỹre. Tapicha marandu ojejerure oñeikotevẽ jave añoite peteĩ tembiaporã oñeme'ẽ térã jerure ojehapykueho hag̃ua.",
  "Cargando ficha": "Oñemyenyhẽhína marandu",
  "Cargando trámites": "Oñemyenyhẽhína tembiaporã",
  "Compartir enlace": "Emboja'o joajuha",
  "Comunicación pública": "Marandu opavavépe g̃uarã",
  "Condiciones de uso de los servicios digitales":
    "Tembiaporã digitaal jeporu mbojojaha",
  "Conocé las novedades, actividades y acontecimientos importantes de nuestra ciudad.":
    "Eikuaa ñane táva marandu pyahu, tembiapo ha mba'e guasu oikóva.",
  "Conocé las novedades, actividades y acontecimientos importantes de nuestra ciudad. Un espacio para mantenernos informados y conectados con nuestra comunidad.":
    "Eikuaa ñane táva marandu pyahu, tembiapo ha mba'e guasu oikóva. Peteĩ tenda ñaime hag̃ua marandúpe ha ñañembojoaju hag̃ua ñande rekoháre.",
  "Consultá con la dependencia responsable para conocer la documentación aplicable.":
    "Eporandu tavão vore omba'apóvape reikuaa hag̃ua kuatiakuéra oñeikotevẽva.",
  "Consultá el directorio de dependencias para elegir el área adecuada.":
    "Ehecha tavão vore ryru eiporavo hag̃ua vore oĩporãva.",
  "Consultá la disponibilidad actual de los canales digitales municipales.":
    "Ehecha tavão rape digitaal ojeporukuaáva ko'ág̃a.",
  "Consultá las funciones y los canales de atención publicados por cada área municipal.":
    "Ehecha tembiapo ha ñangareko rape peteĩteĩ tavão vore omoherakuãva.",
  "Consultá los horarios y las condiciones de acceso por los canales de atención municipal.":
    "Ehecha aravo ha jeike mbojojaha tavão ñangareko rape rupive.",
  "Consultá solicitudes o accedé a la bandeja de Mesa de Entrada según el rol asignado por tu municipalidad.":
    "Ehecha jerure térã eike Kuatia Ñemoguahẽha rendápe nde tavão ome'ẽva ndéve rembiapo rupive.",
  "Consulta territorial y parcelaria de carácter referencial.":
    "Yvy ha yvy pehẽngue marandu jehechaukaha.",
  "Consultar disponibilidad": "Ehecha ojeporukuaápa",
  "Consultar fuente vinculada": "Ehecha marandu ypy joajupyre",
  "Contacto y atención ciudadana": "Tavaygua ñangareko ha ñe'ẽha",
  "Crear cuenta": "Ejapo cuenta",
  Crédito: "Mávapa ojapo",
  "Crédito:": "Mávapa ojapo:",
  "Cuando exista una interrupción programada, se informará en esta sección.":
    "Oĩramo tembiaporã jejoko oñembosako'ipyre, ojeikuaaukáta ko vorépe.",
  "Cursos, capacitación y aprendizaje municipal.":
    "Mbo'esyry, ñembokatupyry ha tavão ñemoarandu.",
  "Dependencias municipales": "Tavao vorekuéra",
  "Desarrollo tecnológico: Arandu Dev.": "Tecnología ñemoheñói: Arandu Dev.",
  "Descubrí Piribebuy": "Eikuaa Piribebuy",
  "Dirección, horarios y canales de contacto de la Municipalidad.":
    "Tavao renda, aravo ha ñe'ẽha rape.",
  "Directorio sin publicaciones": "Tavao vore ryru marandu'ỹre",
  "Disponible para consulta.": "Ojeporukuaa ojehecha hag̃ua.",
  "Documentos publicados por periodo, dependencia y categoría.":
    "Kuatiakuéra oñemyasãiva arange pukukue, tavão vore ha mba'e aty rupive.",
  "Documentos públicos organizados por vigencia, responsable y formato.":
    "Kuatiakuéra opavavépe g̃uarã oñemohendáva tekove, omba'apóva hese ha ysaja rupive.",
  "El contenido solicitado no está disponible.": "Marandu ojejeruréva ndojeporukuaái.",
  "El portal reúne información y servicios municipales en un mismo lugar, manteniendo la atención presencial para quienes la necesiten.":
    "Tavão rokẽ ombyaty marandu ha tembiaporã peteĩ hendápe, ha oñangareko tovake umi oikotevẽvape.",
  "Elegí el canal adecuado": "Eiporavo tape oĩporãva",
  "Enviar instrucciones": "Emondo jehechaukarã",
  "Este portal reúne información institucional, servicios ciudadanos, noticias, movilidad y herramientas de gestión del Gobierno Municipal de Piribebuy.":
    "Ko tavão rokẽ ombyaty Piribebuy Tavao Rekuái marandu, tavaygua rembiaporã, marandu pyahu, jeguatapy ha ñangareko rembiporu.",
  "Estructura de responsabilidades": "Tembiaporã ñemohenda",
  "Filtrar resultados": "Embogua ojejuhúva",
  "Filtros de trámites": "Tembiaporã mboguaha",
  formación: "ñembokatupyry",
  "Gestión territorial": "Yvy ñangareko",
  "Gobierno Municipal de Piribebuy.": "Piribebuy Tavao Rekuái.",
  "Guardar ficha (impresión)": "Eñongatu marandu (jeimprimi)",
  "Guía turística en actualización": "Jeheguata rape oñembopyahuhína",
  "Identidad cultural de Piribebuy": "Piribebuy arandupy reko tee",
  "Imprimir o guardar": "Eimprimi térã eñongatu",
  "Información esencial sobre alcance, límites y uso responsable.":
    "Marandu tenondegua ohupytyha, rembe'y ha jeporu hekopetére.",
  "información pública": "marandu opavavépe g̃uarã",
  "Información pública ordenada y reutilizable":
    "Marandu opavavépe g̃uarã oñemohendáva ha ojeporujeykuaa",
  "Ingresá con una cuenta confirmada. Los permisos se consultan antes de abrir el portal ciudadano o la gestión municipal.":
    "Eike cuenta oñemoañetéva rupive. Ñemoneĩ ojehecha tavaygua rokẽ térã tavão ñangareko ojepe'a mboyve.",
  "Intendencia Municipal": "Tavao Ruvicha Renda",
  "La autoridad ejecutiva, la Junta y las dependencias se presentan de forma separada y comprensible.":
    "Tavao ruvicha, Tavao Aty ha vorekuéra ojehechauka ojuavy ha hesakã hag̃ua.",
  "La ficha solicitada no existe en este catálogo.":
    "Marandu ojejeruréva ndaipóri ko tembiaporã ryrupe.",
  "La información publicada en cada trámite indica sus requisitos, modalidad y dependencia responsable. Ante una diferencia, prevalece la normativa municipal vigente.":
    "Peteĩteĩ tembiaporã marandu ohechauka oñeikotevẽva, mba'éichapa ojejapo ha tavão vore omba'apóva hese. Ojoavýramo, oñemotenonde tavão mbojojaha oikovéva.",
  "La Junta Municipal publicará aquí su integración confirmada.":
    "Tavao Aty omoherakuãta ko'ápe ijaty oñemoañetéva.",
  "La Municipalidad organiza servicios locales, administra recursos, orienta trámites y articula políticas comunitarias dentro de las competencias establecidas por la normativa paraguaya.":
    "Tavao omohenda tembiaporã, oñangareko viru ha mba'erepy rehe, oisãmbyhy tembiaporã ha ombojoaju tekoha rape Paraguái mbojojaha ome'ẽva pu'aka ryepýpe.",
  "La orientación general no sustituye una solicitud formal ni genera un expediente.":
    "Jehechauka tuichakue nomyengoviái jerure tee ha ndojapói kuatiaryru.",
  "La plataforma diferencia contenido público, información interna y datos personales mediante autenticación y políticas de acceso.":
    "Ko plataforma ombojuavy marandu opavavépe g̃uarã, marandu hyepypegua ha tapicha marandu jeike ñemoañete ha jeike mbojojaha rupive.",
  "Las dependencias y sus canales se publican desde registros administrados; la fuente normativa sigue siendo la documentación municipal oficial.":
    "Tavao vore ha hape oñemyasãi registro oñeñangarekóva guive; mbojojaha ypy niko tavão kuatia tee.",
  "Las estadísticas de uso registran únicamente la sección consultada, la fecha y un identificador aleatorio de la sesión. No se almacenan direcciones IP ni parámetros de búsqueda.":
    "Jeporu papapy oñongatu vore ojehecháva, arange ha jeike rechaukaha po'a rupiveguáva añoite. Noñongatúi IP renda ni jeheka marandu.",
  "Las herramientas digitales no reemplazan la atención presencial. Cada persona puede elegir el canal más adecuado según su necesidad.":
    "Tembiporu digitaal nomyengoviái ñangareko tovake. Peteĩteĩ tapicha ikatu oiporavo tape oĩporãvéva oikotevẽháicha.",
  "Los canales de cada dependencia se muestran cuando están publicados en el directorio municipal.":
    "Peteĩteĩ tavão vore rape ojehechauka oñemyasãi vove tavão vore ryrupe.",
  "Los canales digitales complementan la atención presencial y permiten organizar consultas y solicitudes con mayor claridad.":
    "Tape digitaal omoirũ ñangareko tovake ha oipytyvõ porandu ha jerure oñemohenda hesakãve hag̃ua.",
  "Los lugares verificados aparecerán aquí cuando sean publicados.":
    "Tenda oñemoañetéva ojehechaukáta ko'ápe oñemyasãi vove.",
  "Lugares turísticos destacados": "Tenda jeheguatarã ojehecharamovéva",
  "Mapa catastral": "Yvy ra'anga catastral",
  "Movilidad y recolección": "Jeguatapy ha ñemono'õ",
  "Municipalidad e institución": "Tavao ha institución",
  "Museo Histórico": "Tembiasakue Róga",
  "Naturaleza cordillerana": "Cordillera tekoha",
  "No hay avisos municipales de interrupción publicados para los servicios visibles en esta página.":
    "Ndaipóri tavão marandu jejoko rehegua oñemyasãiva ko toguépe ojehecháva tembiaporãme g̃uarã.",
  "No hay dependencias con información pública disponible en este momento.":
    "Ndaipóri tavão vore oguerekóva marandu opavavépe g̃uarã ko'ág̃a.",
  "No hay documentos para esta búsqueda": "Ndaipóri kuatia ko jehekápe g̃uarã",
  "Nómina basada en los resultados preliminares del TREP 2026. La conformación se actualizará cuando finalice la proclamación oficial.":
    "Téra rysýi oñemopyenda TREP 2026 resultado ñepyrũguáre. Aty oñembopyahúta proclamación tee opa vove.",
  "Nómina en actualización": "Téra rysýi oñembopyahuhína",
  "Noticia no encontrada": "Marandu ndojejuhúi",
  "Nuestra ciudad, más cerca de vos. Información, servicios y participación ciudadana en un solo lugar.":
    "Ñane táva, hi'ag̃uive ndehegui. Marandu, tembiaporã ha tavaygua ñepytyvõ peteĩ hendápente.",
  "Obras con información comprensible": "Tembiapo marandu hesakãva reheve",
  "Organigrama institucional": "Tavao ñemohenda ra'anga",
  "Piribebuy histórica": "Piribebuy rembiasakue",
  "Piribebuy, Cordillera, Paraguay": "Piribebuy, Cordillera, Paraguái",
  "Poncho Para’i y artesanía": "Poncho Para'i ha pópe guare",
  "Presentá tu solicitud y recibí un número de expediente para consultar su estado.":
    "Emoinge nde jerure ha ejapyhy kuatiaryru papapy rehecha hag̃ua heko.",
  "presentar una nota": "emoinge kuatia",
  "Probá con otra palabra o seleccioná una categoría diferente.":
    "Eiporu ambue ñe'ẽ térã eiporavo ambue mba'e aty.",
  "Probá otra palabra o quitá alguno de los filtros.":
    "Eiporu ambue ñe'ẽ térã eipe'a mboguaha.",
  recolección: "ñemono'õ",
  "Recopilar menos, proteger mejor": "Embyaty mbovyve, eñangareko porãve",
  "Recorridos, transporte público y servicio de recolección.":
    "Tape, mba'yrumýi opavavépe g̃uarã ha ñemono'õ rembiaporã.",
  "Recuperación verificada": "Jeike jeguerujey oñemoañetéva",
  "Recurso visual institucional": "Tavao ta'anga rembiporu",
  rendición: "viru jeporu rechauka",
  "Requisitos, costos, plazos y modalidades de atención.":
    "Oñeikotevẽva, hepykue, aravo ha ñangareko rape.",
  "Revisá el periodo y la fecha de actualización antes de utilizar la información.":
    "Ehechajey arange pukukue ha oñembopyahu hague reiporu mboyve marandu.",
  "Seguimiento de ubicación, presupuesto, fuente, contratista, fechas y avance publicado.":
    "Tenda, virurã, moõguipa ou, tembiapo ojapóva, arange ha tembiapo ohoha oñemyasãiva rapykueho.",
  "Servicios municipales más claros y accesibles":
    "Tavao rembiaporã hesakã ha ojeikeporãvéva",
  "Sin avisos de mantenimiento publicados": "Ndaipóri ñangareko marandu oñemyasãiva",
  teléfono: "pumbyry",
  "Trámite no encontrado": "Tembiaporã ndojejuhúi",
  "Trámites claros, antes de empezar": "Tembiaporã hesakãva, eñepyrũ mboyve",
  "trámites encontrados": "tembiaporã ojejuhúva",
  "Trámites y servicios": "Tembiaporã ha ñangareko",
  Tránsito: "Tape jeguata",
  "Transparencia activa": "Tesakã oikovéva",
  "Transparencia y documentos públicos": "Tesakã ha kuatiakuéra opavavépe g̃uarã",
  Tributación: "Jehepyme'ẽ tavãope",
  ubicación: "tenda",
  "Un espacio institucional para acercarse al patrimonio, al Museo Histórico, al Poncho Para’i de 60 Listas, a la artesanía y a la agenda cultural de nuestra ciudad.":
    "Peteĩ tavão renda jaikuaa hag̃ua ñane mba'e teéva, Tembiasakue Róga, Poncho Para'i 60 Listas, pópe guare ha ñane táva arandupy rembiaporã.",
  "Una selección de espacios naturales, históricos y culturales relevados en el distrito.":
    "Distrito ryepýpe tenda tekoha, tembiasakue ha arandupy rehegua ojeporavóva.",
  "Una solicitud queda presentada cuando el sistema asigna un número de expediente y emite la constancia correspondiente.":
    "Peteĩ jerure oñemog̃uahẽma sistema ome'ẽ vove kuatiaryru papapy ha oguenohẽ vove kuatiarechaukaha.",
  "Usá al menos 10 caracteres y no reutilices una contraseña anterior.":
    "Eiporu 10 tai térã hetave ha ani reiporujey ñe'ẽñemi ymaguare.",
  "Ver ficha": "Ehecha marandu",
  "Ver ubicación": "Ehecha tenda",
  "Volver a ingresar": "Eikejey",
  "Volver a noticias": "Ejevy marandukuérape",
  "Volver a trámites": "Ejevy tembiaporãme",
  "Volver al portal": "Ejevy tavão rokẽme",
  "Ya tengo cuenta": "Aguerekóma cuenta",
  "Avañe’ẽ": "Avañe’ẽ",
  "Guaraní Ñe’ẽ": "Guaraní Ñe’ẽ",
  "¿Esta gestión tiene validez oficial?": "Ko tembiapo añeteguápa tavãope?",
  "No. Esta plataforma es un entorno demostrativo y no recibe trámites oficiales.":
    "Nahániri. Ko plataforma techaukarãnte ha nomog̃uahẽi tembiaporã tee.",
  "¿Puedo presentar documentación real?": "Ikatúpa amoinge kuatia añetegua?",
  "No. Utilizá únicamente archivos ficticios preparados para la demostración.":
    "Nahániri. Eiporu kuatia techaukarã oñembosako'iva'ekue añónte.",
  "Ingresá una nota dirigida a una dependencia municipal y seguí su recepción.":
    "Emoinge kuatia tavão vore peguarã ha ehapykueho iñeg̃uahẽ.",
  "Recepción inicial estimada: 2 días hábiles":
    "Ñeg̃uahẽ tenondegua oñeimo'ãva: 2 ára oñemba'apóva",
  "Datos de identificación": "Tekotee marandu",
  "Datos mínimos de la persona solicitante.": "Ojeruréva marandu michĩvéva.",
  "Descripción clara": "Mombe'u hesakãva",
  "Asunto, solicitud y dependencia sugerida.":
    "Mba'e rehegua, jerure ha tavão vore oñeimo'ãva.",
  "Documentación de respaldo": "Kuatia pytyvõrã",
  "Archivos demostrativos cuando sean necesarios.":
    "Kuatia techaukarã oñeikotevẽ jave.",
  "Campo configurable — pendiente de validación jurídica municipal.":
    "Tenda oñembosako'ikuaáva — oha'ãrõ tavão léi jehechajey.",
  "Mesa de Entrada — canal demostrativo": "Kuatia Ñemoguahẽha — techaukarã rape",
  "Mesa de Entrada (provisional)": "Kuatia Ñemoguahẽha (sapy'agua)",
  "Consulta de expediente": "Kuatiaryru jehecha",
  "Conocé el estado y las últimas actuaciones visibles de una presentación.":
    "Eikuaa peteĩ kuatia jepresenta reko ha hembiapo ipyahuvéva ojehecháva.",
  "Consulta inmediata": "Jehecha pya'e",
  "Procedimiento demostrativo sujeto a validación.":
    "Jeguata techaukarã oikotevẽ jehechajey.",
  "Atención Ciudadana": "Tavaygua ñangareko",
  "Archivo (provisional)": "Kuatia ñongatuha (sapy'agua)",
  "Solicitud de acceso a información pública":
    "Jerure marandu opavavépe g̃uarã jeike rehegua",
  "Consultá el canal previsto para solicitar información pública.":
    "Ehecha tape oñembosako'íva rejerure hag̃ua marandu opavavépe g̃uarã.",
  "Gratuito, salvo costos de reproducción aplicables":
    "Reiete, ndaipóriramo kuatia mbohetave repykue",
  "Sujeto al plazo legal aplicable": "Léi aravo oikovéva poguýpe",
  "Ley N.º 5282/2014 y reglamentación aplicable.":
    "Léi N.º 5282/2014 ha mbojojaha oikovéva.",
  "Oficina de Acceso a la Información Pública": "Marandu Opavavépe G̃uarã Jeike Renda",
  "Acceso a la Información Pública (provisional)":
    "Marandu Opavavépe G̃uarã Jeike (sapy'agua)",
  "Reclamo por servicios urbanos": "Táva rembiaporã rehe ñe'ẽngatu",
  "Consultá cómo comunicar una necesidad relacionada con servicios urbanos.":
    "Ehecha mba'éichapa remomarandúta reikotevẽva táva rembiaporã rehe.",
  "Variable según tipo de reclamo": "Iñambue ñe'ẽngatu rehe",
  "Pendiente de validación municipal.": "Oha'ãrõ tavão jehechajey.",
  "Obras y Servicios": "Tembiapo ha ñangareko",
  "Obras y Servicios (provisional)": "Tembiapo ha ñangareko (sapy'agua)",
  "Solicitud preliminar de patente comercial": "Ñemuhára patente jerure tenondegua",
  "Orientación inicial sobre requisitos para una actividad comercial.":
    "Ñemuhára rembiapo oñeikotevẽva rehe jehechauka tenondegua.",
  "Variable según actividad y ordenanza vigente":
    "Iñambue tembiapo ha ordenanza oikovéva rehe",
  "A confirmar después de verificar requisitos":
    "Oñemoañetéta oñeikotevẽva ojehechajey rire",
  "Ordenanzas vigentes — pendiente de carga y validación.":
    "Ordenanza oikovéva — oha'ãrõ ñemyenyhẽ ha jehechajey.",
  Recaudaciones: "Viru ñembyaty",
  "Recaudaciones (provisional)": "Viru ñembyaty (sapy'agua)",
  "Consulta de requisitos de habilitación vehicular":
    "Mba'yrumýi ñemoneĩ oñeikotevẽva jehecha",
  "Revisá la lista preliminar de requisitos y el canal de atención.":
    "Ehechajey oñeikotevẽva rysýi tenondegua ha ñangareko rape.",
  "Según ordenanza tributaria vigente":
    "Ordenanza jehepyme'ẽ rehegua oikovéva he'iháicha",
  "Atención presencial por orden de llegada": "Ñangareko tovake og̃uahẽháicha",
  "Ordenanza tributaria vigente — pendiente de validación.":
    "Ordenanza jehepyme'ẽ rehegua oikovéva — oha'ãrõ jehechajey.",
  "Tránsito (provisional)": "Tape jeguata (sapy'agua)",
  "Solicitud de certificado de residencia municipal": "Tavão jeikoha kuatia jerure",
  "Ficha preliminar; el procedimiento y su competencia deben validarse.":
    "Marandu tenondegua; jeguata ha mávapa ojapóta ojehechajeyva'erã.",
  "Por confirmar": "Oñemoañete hag̃ua",
  "Sin validación jurídica en esta demostración.":
    "Ndaipóri léi jehechajey ko techaukarãme.",
  "Atención Ciudadana (provisional)": "Tavaygua ñangareko (sapy'agua)",
  "Solicitud de audiencia o reunión institucional": "Ñomongeta térã tavão aty jerure",
  "Consultá cómo proponer una reunión con una dependencia municipal.":
    "Ehecha mba'éichapa rejeruréta aty peteĩ tavão vore ndive.",
  "Respuesta orientativa: 5 días hábiles": "Mbohovái oñeimo'ãva: 5 ára oñemba'apóva",
  "Procedimiento interno pendiente de validación.":
    "Jeguata hyepypegua oha'ãrõ jehechajey.",
  "Secretaría General (provisional)": "Secretaría General (sapy'agua)",
  "Esta noticia forma parte de Piribebuy Digital. Los nombres, fechas operativas y actividades son demostrativos y deberán validarse antes de una publicación oficial.":
    "Ko marandu oike Piribebuy Digitaal-pe. Téra, arange ha tembiapokuéra techaukarãnte ha ojehechajeyva'erã oñemyasãi tee mboyve.",
  "Obra ficticia incluida para demostrar seguimiento público de avance, presupuesto y documentos.":
    "Tembiapo techaukarã omoañetéva mba'éichapa ojehechauka tenondeho, virurã ha kuatiakuéra.",
  "Descripción ficticia utilizada exclusivamente para demostrar el recorrido del expediente.":
    "Mombe'u techaukarã ojeporúva kuatiaryru rape ojehechauka hag̃ua añoite.",
  "Corrección requerida": "Oñeikotevẽ ñemyatyrõ",
  "Un expediente demostrativo requiere información adicional.":
    "Peteĩ kuatiaryru techaukarã oikotevẽ marandu joapy.",
  "Expediente admitido": "Kuatiaryru oñemoneĩva",
  "Tu presentación demostrativa fue admitida.": "Nde kuatia techaukarã oñemoneĩma.",
  "Acceso PY02 → Terminal Piribebuy": "Jeike PY02 → Piribebuy Terminal",
  "Cruce PY02 / Ramal Piribebuy": "Joasa PY02 / Piribebuy rape yke",
  "Guazú Rocai": "Guazú Rocai",
  "San Blas": "San Blas",
  "Centro de Piribebuy": "Piribebuy mbyte",
  "Terminal de Ómnibus": "Mba'yrumýi terminal",
  "LÍNEA 197 · ASUNCIÓN → PIRIBEBUY": "LÍNEA 197 · PARAGUAY → PIRIBEBUY",
  "Estación de Buses de Asunción": "Paraguay mba'yrumýi renda",
  "Cuatro Mojones": "Cuatro Mojones",
  "Mercado de Abasto": "Abasto ñemuha",
  "Calle Última": "Calle Última",
  "San Lorenzo": "San Lorenzo",
  Capiatá: "Capiatá",
  Itauguá: "Itauguá",
  Ypacaraí: "Ypacaraí",
  Caacupé: "Caacupé",
  "Acceso a Piribebuy": "Piribebuy jeikeha",
  "Base La Caacupeña": "La Caacupeña renda",
  "LÍNEA 197 · PIRIBEBUY → ASUNCIÓN": "LÍNEA 197 · PIRIBEBUY → PARAGUAY",
  "RECORRIDO DE REFERENCIA — RECOLECTOR 01": "TAPE TECHARÃ — ÑEMONO'ÕHA 01",
  Centro: "Mbyte",
  "Santa Ana": "Santa Ana",
  "Virgen del Rosario": "Rosario Tupãsy",
  "María Auxiliadora": "María Auxiliadora",
  "Salida hacia disposición final": "Ñesẽ mba'e ky'a renda pahápe",
  "Unidad 01": "Mba'yrumýi 01",
  "Unidad 02": "Mba'yrumýi 02",
  "Unidad 03": "Mba'yrumýi 03",
  "Unidad 04": "Mba'yrumýi 04",
  "Unidad 05": "Mba'yrumýi 05",
  "Unidad 06": "Mba'yrumýi 06",
  "Recolector 01": "Ñemono'õha 01",
  "Municipalidad de Piribebuy": "Piribebuy Tavao",
  "Una casa pública para una ciudad con historia":
    "Tetã róga peteĩ táva rembiasakuépe g̃uarã",
  "La Municipalidad acompaña la vida cotidiana de Piribebuy: ordena servicios, recibe gestiones y trabaja con los barrios y compañías del distrito.":
    "Tavao omoirũ Piribebuy rekove ára ha ára: omohenda tembiaporã, omog̃uahẽ jerure ha omba'apo tava'i ha compañía ndive.",
  "Abogado y vecino de Piribebuy, Rodolfo Enmanuel Gini Orue encabeza la Intendencia Municipal con la responsabilidad de administrar los recursos públicos, coordinar los servicios y sostener un vínculo directo con la comunidad.":
    "Abogádo ha Piribebuy vecino, Rodolfo Enmanuel Gini Orue omotenonde Tavao Mburuvichaha, oñangareko viru opavavépe g̃uarãre, omohenda tembiaporã ha oñe'ẽ hag̃ua tekoha ndive.",
  "Piribebuy se recorre con tiempo": "Piribebuy ojeikuaa mbeguekatu",
  "Entre el casco histórico y los caminos de la cordillera, la ciudad reúne memoria, oficios y paisajes que siguen siendo parte de la vida diaria.":
    "Táva ymaguare ha yvyty rape apytépe, Piribebuy ombyaty mandu'a, tembiapo ha tekoha oikovéva gueteri ára ha ára.",
  "Acá la historia no está guardada detrás de una sola puerta. Aparece en el Santuario, en el museo, en la trama del poncho para’i y en los relatos que acompañan cada recorrido. Visitar Piribebuy también es conversar con su gente y entender por qué estos lugares siguen importando.":
    "Ko'ápe tembiasakue noñembotýi peteĩ okẽ rapykuéri. Ojehecha Santuario-pe, museo-pe, poncho para'i ñandutípe ha mombe'ukuéra tape reheguápe. Reju Piribebuy-pe he'ise avei reñomongeta itavayguakuéra ndive ha reikuaa mba'érepa ko'ã tenda iporã gueteri.",
  "La cuenta no tiene una municipalidad asignada.":
    "Ko cuenta ndoguerekói tavão oñeme'ẽva chupe.",
  "Cargando estructura académica": "Oñemyenyhẽhína mbo'ehao ñemohenda",
  "Editor del curso": "Mbo'esyry mbosako'iha",
  "Publicá desde adentro hacia afuera: lecciones, unidades, evaluación y, finalmente, curso.":
    "Emyasãi hyepýgui okápe: mbo'epy, aty, ñeha'ã ha ipahápe mbo'esyry.",
  "Estado del curso": "Mbo'esyry reko",
  Borrador: "Hai pyre",
  Publicado: "Oñemyasãiva",
  Archivado: "Oñemohendáva",
  "Materias y unidades": "Mbo'erã ha aty",
  "Nombre de la materia": "Mbo'erã réra",
  "Agregar materia": "Embojoapy mbo'erã",
  Materia: "Mbo'erã",
  Seleccionar: "Eiporavo",
  "Título de la unidad": "Aty réra",
  "Agregar unidad": "Embojoapy aty",
  Retirar: "Eipe'a",
  Publicar: "Emyasãi",
  Lecciones: "Mbo'epykuéra",
  Unidad: "Aty",
  Título: "Teratee",
  "Identificador URL": "URL rechaukaha",
  Objetivo: "Jehupytyrã",
  "Contenido en Markdown": "Marandu Markdown-pe",
  "Duración estimada (minutos)": "Aravo oñeimo'ãva (aravo'i)",
  "Crear lección": "Ejapo mbo'epy",
  "Recursos externos": "Tembiporu okapegua",
  Lección: "Mbo'epy",
  Tipo: "Mba'éichagua",
  Enlace: "Joajuha",
  Video: "Ta'angamýi",
  Interactivo: "Oñondive ojeporúva",
  "URL del recurso": "Tembiporu URL",
  "Fuente o autor": "Ypy térã apohára",
  "URL de la fuente": "Ypy URL",
  "Agregar recurso": "Embojoapy tembiporu",
  "Banco de preguntas": "Porandu ryru",
  General: "Opavave rehegua",
  "Sin unidad": "Aty'ỹre",
  Pregunta: "Porandu",
  Opción: "Poravorã",
  "Opción correcta": "Poravorã hekopeguáva",
  Explicación: "Ñemyesakã",
  Dificultad: "Hasykue",
  Inicial: "Ñepyrũgua",
  Intermedia: "Mbytegua",
  Avanzada: "Tenondegua",
  "Tipo de fuente": "Ypy mba'éichagua",
  Original: "Ypykue",
  "Referencia oficial": "Marandu tee",
  "Con licencia": "Licencia reheve",
  "Referencia o licencia": "Marandu térã licencia",
  "Crear pregunta": "Ejapo porandu",
  "opciones · banco privado": "poravorã · ryru ñemigua",
  Evaluaciones: "Ñeha'ãkuéra",
  "Duración (minutos)": "Aravo (aravo'i)",
  "Aprobación (%)": "Ñemoneĩ (%)",
  "Crear evaluación": "Ejapo ñeha'ã",
  Evaluación: "Ñeha'ã",
  Puntaje: "Púnto",
  "Asignar pregunta": "Emoĩ porandu",
  "min ·": "aravo'i ·",
  "El curso todavía no tiene estructura": "Mbo'esyry ne'ĩra gueteri oñemohenda",
  "Cargo municipal guardado con trazabilidad.":
    "Tavão cargo oñeñongatu tapykueho reheve.",
  "Persona, dependencia, cargo, rol y funciones quedaron vinculados.":
    "Tapicha, tavão vore, cargo, rol ha tembiaporã oñembojoajúma.",
  "La asignación fue finalizada y el acceso asociado quedó revocado.":
    "Ñeme'ẽ oñemohu'ã ha jeike ojoajúva oñembotýma.",
  "La visibilidad del módulo fue actualizada y auditada.":
    "Vore jehechauka oñembopyahu ha ojehechajeyma.",
  "Gobierno de acceso": "Jeike ñangareko",
  "Organización, roles y visibilidad": "Ñemohenda, rol ha jehechauka",
  "Personal, dependencias, funciones y secciones habilitadas.":
    "Mba'apohára, tavão vore, tembiaporã ha vore oñemoneĩva.",
  "Accesos protegidos": "Jeike oñeñangarekóva",
  "No se pudo cargar la organización municipal": "Ndaikatúi oñemyenyhẽ tavão ñemohenda",
  "Intentá nuevamente o comunicá el inconveniente al área técnica.":
    "Eha'ãjey térã emomarandu apañuãi área técnica-pe.",
  "Cargando gobierno de acceso": "Oñemyenyhẽhína jeike ñangareko",
  Estructura: "Ñemohenda",
  "Cargos y asignaciones": "Cargo ha ñeme'ẽ",
  "Personal, cargos y responsabilidades vigentes.":
    "Mba'apohára, cargo ha tembiaporã oikovéva.",
  "Tu acceso permite revisar la estructura, pero no modificar nombramientos.":
    "Nde jeike oheja rehechajey ñemohenda, hákatu ndaikatúi remoambue téra ñemoĩ.",
  Vigente: "Oikovéva",
  Licencia: "Licencia",
  Finalizada: "Oñemohu'ãva",
  "Asignación principal": "Ñeme'ẽ tenondegua",
  "Motivo obligatorio": "Mba'érepa tekotevẽva",
  "Finalizar y revocar": "Emohu'ã ha emboty",
  "Finalizar asignación": "Emohu'ã ñeme'ẽ",
  "Todavía no hay personal asignado": "Ne'ĩra gueteri oĩ mba'apohára oñeme'ẽva",
  "Matriz efectiva": "Matriz oikóva",
  "Roles y capacidades": "Rol ha ikatupyry",
  "Los permisos se expresan como acciones concretas y alcance municipal o departamental.":
    "Ñemoneĩ ojehechauka tembiapo añetéramo ha ijapy tavão térã vore peve.",
  Municipio: "Tavao",
  Propio: "Imba'éva",
  Disponibilidad: "Jeporukuaa",
  "Secciones y módulos": "Vore ha módulo",
  "Ocultar una sección cambia su disponibilidad; no sustituye los controles RLS.":
    "Peteĩ vore ñemi omoambue ijeporukuaa; nomyengoviái RLS control.",
  "Motivo que quedará en auditoría": "Mba'érepa opytátava jehechajeyme",
  Ciudadanía: "Tavayguakuéra",
  Visible: "Ojehecháva",
  Oculto: "Oñemíva",
  Esencial: "Tekotevẽva",
  Ocultar: "Emi",
  Mostrar: "Ehechauka",
  "Crear cargo": "Ejapo cargo",
  "Ej.: Director de Catastro o Jefe de Tesorería.":
    "Techapyrã: Catastro sãmbyhyhára térã Tesorería ruvicha.",
  "Nombre del cargo": "Cargo réra",
  "Código interno": "Código hyepypegua",
  "Cargo transversal": "Cargo opa vorépe",
  "Responsabilidades, una por línea": "Tembiaporã, peteĩteĩva peteĩ tairendápe",
  "Cargo de conducción": "Sãmbyhy cargo",
  "Guardar cargo": "Eñongatu cargo",
  "Asignar persona": "Emoĩ tapicha",
  "Une estructura organizacional y acceso técnico.":
    "Ombojoaju aty ñemohenda ha jeike técnica.",
  "Persona registrada": "Tapicha oñemboheraguapýva",
  Cargo: "Cargo",
  "Rol técnico": "Rol técnica",
  "Función principal": "Tembiapo tenondegua",
  "Límites de autoridad": "Mburuvicha pu'aka rembe'y",
  "Fin opcional": "Paha ikatúva",
  "Motivo auditable": "Mba'érepa ojehechajeykuaáva",
  "Crear asignación": "Ejapo ñeme'ẽ",
  "Módulo temporalmente oculto": "Módulo oñemíva sapy'ami",
  "Verificando disponibilidad": "Ojehechahína ojeporukuaápa",
  "Sección temporalmente no disponible": "Vore ndojeporukuaái sapy'ami",
  Matemática: "Papapykuaa",
  "Razonamiento y contenidos del nivel medio indicados en los ejes temáticos.":
    "Apytu'ũ jeporu ha mbo'erã nivel medio rehegua oñemoĩva temakuérape.",
  "Lengua Castellana y Literatura": "Castellano ñe'ẽ ha ñe'ẽporãhaipyre",
  "Comprensión, vocabulario y competencias lingüísticas del nivel medio.":
    "Ñe'ẽkuaa, ñe'ẽndy ha nivel medio ñe'ẽ katupyry.",
  "Reglamento General de Becas": "Beca Mbojojaha Guasu",
  "Condiciones y reglas que cada postulante debe verificar en la convocatoria vigente.":
    "Teko ha mbojojaha peteĩteĩ ojeruréva ohechajeyva'erã ñehenói oikovévape.",
  "Formación y oportunidades para la comunidad": "Ñemoarandu ha pa'ũ tekoha peguarã",
  "Ir a mi aprendizaje": "Tereho che ñemoarandúpe",
  "Portal oficial": "Rokẽ tee",
  "Material de preparación": "Ñembosako'i rembiporu",
  "Esta academia no representa a ITAIPÚ ni al Programa Becas Gobierno del Paraguay. Las condiciones vigentes deben confirmarse en el portal oficial.":
    "Ko mbo'ehao nomoĩri ITAIPÚ ni Paraguái Rekuái Beca Programa rérape. Teko oikovéva oñemoañeteva'erã rokẽ teépe.",
  "Áreas informadas por la convocatoria": "Mbo'erã aty ñehenói oikuaaukáva",
  "Cursos disponibles": "Mbo'esyry ojeporukuaáva",
  "Consultando cursos": "Ojehechahína mbo'esyry",
  "Todavía no hay cursos publicados": "Ne'ĩra gueteri oĩ mbo'esyry oñemyasãiva",
  "Dirigido a:": "Mávape g̃uarã:",
  Inscribirme: "Añemboheraguapy",
  "Una experiencia de aprendizaje clara y ordenada":
    "Ñemoarandu hesakã ha oñemohenda porãva",
  "Tablero personal": "Che tablero",
  "Reuní tus cursos activos y las próximas actividades en un solo lugar.":
    "Embyaty nde mbo'esyry oikovéva ha tembiapo oúva peteĩ hendápente.",
  "Contenido por temas": "Marandu téma rehe",
  "Cada curso puede organizar materias, unidades, lecciones y recursos.":
    "Peteĩteĩ mbo'esyry ikatu omohenda mbo'erã, aty, mbo'epy ha tembiporu.",
  "Práctica y evaluación": "Ñembokatupyry ha ñeha'ã",
  "Los simulacros guardan el resultado y corrigen las respuestas del lado seguro.":
    "Ñeha'ã techaukarã oñongatu osẽva ha omyatyrõ mbohovái hendápe hekorosãva.",
  "Respondé todas las preguntas antes de entregar.":
    "Embohovái opa porandu emondo mboyve.",
  "Preparando tu aprendizaje": "Oñembosako'ihína ne ñemoarandu",
  "Cursos inscritos, práctica y simulacros con resultados persistentes.":
    "Mbo'esyry reñemboheraguapyha, ñembokatupyry ha ñeha'ã osẽva opytáva.",
  "Ver oferta pública": "Ehecha mbo'esyry opavavépe g̃uarã",
  "Resumen de aprendizaje": "Ñemoarandu mombykypyre",
  "Mis cursos": "Che mbo'esyry",
  "Actividades disponibles": "Tembiapo ojeporukuaáva",
  "Cursos publicados": "Mbo'esyry oñemyasãiva",
  "Simulacro entregado": "Ñeha'ã oñemondóva",
  "puntos ·": "púnto ·",
  "Aún no estás inscripto": "Ne'ĩra gueteri reñemboheraguapy",
  "En curso": "Ojejapohína",
  Completado: "Oñemohu'ãva",
  "actividades publicadas": "tembiapo oñemyasãiva",
  "Simulacros disponibles": "Ñeha'ã ojeporukuaáva",
  "Sin simulacros publicados": "Ndaipóri ñeha'ã oñemyasãiva",
  Iniciar: "Eñepyrũ",
  "Explorar cursos": "Ehecha mbo'esyrykuéra",
  "Ya estás inscripto": "Reñemboheraguapýma",
  "Simulacro en curso": "Ñeha'ã ojejapohína",
  "Respondé todas las preguntas": "Embohovái opa porandu",
  "Entregando…": "Oñemondohína…",
  "Entregar simulacro": "Emondo ñeha'ã",
  "Curso creado como borrador. No será público hasta completar y validar su contenido.":
    "Mbo'esyry ojejapo hai pyréramo. Ndojehechaukamo'ãi oñemyenyhẽ ha ojehechajey peve imarandu.",
  "Administración académica": "Mbo'ehao ñangareko",
  "Contenidos y cursos": "Marandu ha mbo'esyry",
  "Todo contenido nuevo comienza como borrador y debe conservar su fuente.":
    "Opa marandu pyahu oñepyrũ hai pyréramo ha oñongatuva'erã ijypykue.",
  "Nuevo borrador": "Hai pyre pyahu",
  "Crear curso": "Ejapo mbo'esyry",
  "Público objetivo": "Mávape g̃uarã",
  "Contenido original": "Marandu ypykue",
  "Material con licencia": "Tembiporu licencia reheve",
  "URL oficial o de licencia": "URL tee térã licencia rehegua",
  "Guardando…": "Oñeñongatuhína…",
  "Crear borrador": "Ejapo hai pyre",
  "Cursos administrados": "Mbo'esyry oñeñangarekóva",
  "Editar contenido": "Embosako'i marandu",
  "Sin cursos": "Mbo'esyry'ỹre",
  Parcelas: "Yvy pehẽngue",
  "Áreas urbanas": "Táva ryepypegua",
  "Límite distrital": "Distrito rembe'y",
  "No pudimos iniciar el mapa.": "Ndaikatúi romoñepyrũ yvy ra'anga.",
  "Revisá la conexión o la compatibilidad WebGL del navegador.":
    "Ehechajey internet joaju térã navegador WebGL jeporukuaa.",
  "Preparando mapa catastral…": "Oñembosako'ihína yvy ra'anga…",
  "Mapa catastral interactivo de Piribebuy": "Piribebuy yvy ra'anga ojeporukuaáva",
  "Tipo de búsqueda catastral": "Yvy marandu jeheka mba'éichagua",
  "Cuenta catastral": "Yvy cuenta",
  Finca: "Yvy",
  Padrón: "Padrón",
  Identificador: "Techaukaha",
  "Manzana / lote": "Manzana / yvy pehẽngue",
  "Valor a buscar": "Marandu ojehekátava",
  "Buscar parcela": "Eheka yvy pehẽngue",
  "Cerrar resultados": "Emboty ojejuhúva",
  Piribebuy: "Piribebuy",
  "Fondo del mapa": "Yvy ra'anga rapykue",
  Mapa: "Yvy ra'anga",
  Satélite: "Satélite",
  Capas: "Jehechaukaha aty",
  "Mi ubicación": "Che renda",
  "Consultando fuente oficial…": "Ojehechahína marandu tee…",
  "Cargando parcelas visibles…": "Oñemyenyhẽhína yvy pehẽngue ojehecháva…",
  "Fuente oficial temporalmente no disponible": "Marandu tee ndojeporukuaái sapy'ami",
  "Hay más de": "Oĩ hetave",
  "parcelas. Acercate para completar la vista.":
    "yvy pehẽngue. Eñemoag̃uive rehechapa hag̃ua.",
  "Información catastral": "Yvy marandu",
  "Información catastral pública": "Yvy marandu opavavépe g̃uarã",
  Distrito: "Distrito",
  "Piribebuy · Cordillera": "Piribebuy · Cordillera",
  "Cerrar información": "Emboty marandu",
  "Fuente oficial": "Marandu tee",
  "Dirección General del Servicio Nacional de Catastro / RUN. Datos de carácter referencial; no constituyen certificación catastral.":
    "Servicio Nacional de Catastro / RUN Sãmbyhyha Guasu. Marandu jehechaukaha; ndaha'éi yvy kuatia ñemoañete.",
  "Abrir visor oficial": "Eipe'a jehechaha tee",
  "Consulta:": "Jehecha:",
  "El texto alternativo de la foto debe tener al menos 3 caracteres.":
    "Ta'anga jehaipyre ambuéva oguerekova'erã 3 tai térã hetave.",
  "Seleccioná una imagen.": "Eiporavo peteĩ ta'anga.",
  "Cargando contenidos": "Oñemyenyhẽhína marandu",
  "Comunicación institucional": "Tavão ñomongeta",
  "Contenidos del portal": "Rokẽ marandu",
  "Noticias, imágenes, autoridades y turismo con publicación trazable y permisos separados.":
    "Marandu, ta'anga, mburuvicha ha jeheguata, ñemyasãi tapykueho ha ñemoneĩ ojueheguáva reheve.",
  "Categorías de contenido": "Marandu atykuéra",
  Imágenes: "Ta'angakuéra",
  "espacios configurados": "tenda oñembohekopyréva",
  Noticiero: "Marandu aty",
  "Editar noticia": "Embosako'i marandu",
  "Nueva noticia": "Marandu pyahu",
  Editando: "Oñembosako'ihína",
  "Editando:": "Oñembosako'ihína:",
  "Editor de noticias": "Marandu ñembosako'iha",
  "Completá español y avañe’ẽ antes de publicar.":
    "Emyenyhẽ castellano ha avañe’ẽme emyasãi mboyve.",
  Importancia: "Mba'eguasukue",
  Normal: "Hepigua",
  Destacada: "Ojehechavéva",
  Urgente: "Pya'eterei",
  Resumen: "Mombykypyre",
  "Texto completo": "Jehaipyre tuichakue",
  "Fecha de publicación": "Ñemyasãi arange",
  Fotografía: "Ta'anga",
  "Texto alternativo de la foto": "Ta'anga jehaipyre ambuéva",
  "Crédito de la foto": "Ta'anga apohára",
  "Fuente externa": "Ypy okapegua",
  "Guardar cambios": "Eñongatu ñemoambue",
  "Crear noticia": "Ejapo marandu",
  "Cancelar edición": "Heja ñembosako'i",
  "· prioridad": "· tenondekue",
  "No hay noticias": "Ndaipóri marandu",
  "Textos públicos": "Jehaipyre opavavépe g̃uarã",
  "Institución y turismo": "Tavao ha jeheguata",
  Turismo: "Jeheguata",
  "Texto principal": "Jehaipyre tenondegua",
  Antetítulo: "Teratee mboyvegua",
  "Biografía del Intendente": "Tavao ruvicha rekove mombe'u",
  "Texto de bienvenida": "Ñemog̃uahẽ jehaipyre",
  "Visible en el portal": "Ojehecha rokẽme",
  "Guardar texto": "Eñongatu jehaipyre",
  "Editar integrante de la Junta": "Embosako'i Tavao Aty réra",
  "Editor de integrantes": "Atyguakuéra ñembosako'iha",
  "Datos del cargo, orden, fuente y visibilidad pública.":
    "Tembiapo, ñemohenda, ypy ha opavavépe jehechauka marandu.",
  "Bancada o afiliación": "Aty térã joaju",
  Orden: "Ñemohenda",
  "Nombre de la fuente": "Ypy réra",
  "Enlace de la fuente": "Ypy joajuha",
  "Fecha de verificación": "Jehechajey arange",
  "Visible en la página pública": "Ojehecha opavavépe g̃uarã toguépe",
  "Proclamación oficial confirmada": "Ñemoherakuã tee oñemoañetéva",
  "Agregar concejal": "Embojoapy concejal",
  "· oficial": "· tee",
  "· preliminar": "· tenondegua",
  "Turismo y cultura": "Jeheguata ha arandupy",
  "Editar lugar turístico": "Embosako'i jeheguata renda",
  "Lugares turísticos": "Jeheguata rendakuéra",
  "Editor de lugares turísticos": "Jeheguata rendakuéra ñembosako'iha",
  "Descripción, ubicación, imagen y visibilidad pública.":
    "Mombe'u, tenda, ta'anga ha opavavépe jehechauka.",
  Naturaleza: "Tekoha",
  Historia: "Tembiasakue",
  Cultura: "Arandupy",
  Circuito: "Jeguata rape",
  "Descripción breve": "Mombe'u mbyky",
  "Ubicación o zona": "Tenda térã tekoha",
  "Enlace de ubicación": "Tenda joajuha",
  "Fuente de verificación": "Jehechajey ypy",
  "Visible en la guía pública": "Ojehecha guía opavavépe g̃uarãme",
  "Agregar lugar": "Embojoapy tenda",
  "· orden": "· ñemohenda",
  Diseño: "Ta'anga apo",
  "Biblioteca visual": "Ta'anga ryru",
  "Cambiar imagen": "Emoambue ta'anga",
  "Editor de imágenes": "Ta'anga ñembosako'iha",
  "Elegí un espacio y cargá una imagen optimizada.":
    "Eiporavo peteĩ tenda ha ehupi ta'anga oñembopya'éva.",
  Reemplazando: "Oñemyengoviahína",
  "Reemplazando:": "Oñemyengoviahína:",
  Reemplazar: "Emyengovia",
  "Espacio del sitio": "Tenda rokẽme",
  "Nombre interno": "Téra hyepypegua",
  Imagen: "Ta'anga",
  "Texto alternativo": "Jehaipyre ambuéva",
  "Crédito o autor": "Apohára térã crédito",
  "Publicar o reemplazar": "Emyasãi térã emyengovia",
  "7 días": "7 ára",
  "30 días": "30 ára",
  "90 días": "90 ára",
  "1 año": "1 ary",
  "Sin variación": "Ñemoambue'ỹre",
  "% respecto al período anterior": "% arange pukukue mboyvegua rehe",
  "Sin actividad registrada.": "Ndaipóri tembiapo oñemboheraguapýva.",
  "Sin movimientos en el período.": "Ndaipóri ñemýi ko arange pukukuépe.",
  "Expedientes recibidos y resueltos": "Kuatiaryru oñemog̃uahẽva ha oñemyesakãva",
  Recibidos: "Oñemog̃uahẽva",
  Resueltos: "Oñemyesakãva",
  "Período del informe": "Marandu arange pukukue",
  "Actualizando indicadores": "Oñembopyahuhína techaukahakuéra",
  Actualizado: "Oñembopyahúva",
  "Asuntos que requieren atención": "Mba'e oikotevẽva ñangareko",
  "No hay alertas operativas pendientes.":
    "Ndaipóri jesarekorã tembiapo rehegua oha'ãrõva.",
  "Indicadores principales": "Techaukaha tenondegua",
  "Expedientes activos": "Kuatiaryru oikovéva",
  "Expedientes resueltos": "Kuatiaryru oñemyesakãva",
  "Recaudación verificada": "Viru ñembyaty oñemoañetéva",
  "Visitas al portal": "Rokẽ jeike",
  "h promedio": "aravo promedio",
  "Expedientes por situación": "Kuatiaryru heko rehe",
  "Ver Tesorería": "Ehecha Tesorería",
  "Accesos de gestión": "Ñangareko jeike",
  "Mapa Catastral": "Yvy Ra'anga",
  "FUENTE OFICIAL": "MARANDU TEE",
  "Catastro · D / 12": "Yvy marandu · D / 12",
  "Preparando mapa…": "Oñembosako'ihína yvy ra'anga…",
  "Mapa interactivo": "Yvy ra'anga ojeporukuaáva",
  "Recorrido realizado": "Tape ojehasámava",
  "Recorrido pendiente": "Tape ojehasátava",
  Seguridad: "Tekorosã",
  "Movilidad y flota": "Jeguatapy ha mba'yrumýi aty",
  "Noticias y diseño": "Marandu ha ta'anga apo",
  "Gestión municipal": "Tavao ñangareko",
  "Cerrar sesión": "Emboty jeike",
  "Error de aplicación": "Aplicación jejavy",
  "No pudimos mostrar esta pantalla": "Ndaikatúi rohechauka ko jehechaha",
  "Puede tratarse de una actualización reciente de la plataforma.":
    "Ikatu plataforma ñembopyahu pyahu rupi oiko.",
  "Restablecer y recargar": "Emoĩjey ha emyenyhẽjey",
  "Movilidad municipal": "Tavao jeguatapy",
  "Sin posición GPS disponible": "Ndaipóri GPS renda ojeporukuaáva",
  "Todavía no hay una unidad habilitada con telemetría vigente para este servicio. El portal no muestra recorridos ni tiempos estimados sin una fuente real.":
    "Ne'ĩra gueteri oĩ mba'yrumýi oñemoneĩva telemetría oikovéva reheve ko tembiaporãme. Rokẽ ndohechaukái tape ni aravo oñeimo'ãva marandu añetegua'ỹre.",
  "Volver a movilidad": "Ejevy jeguatapýpe",
  "Transporte ciudadano": "Tavaygua mba'yrumýi",
  GPS: "GPS",
  "Información del vehículo": "Mba'yrumýi marandu",
  "Servicio Piribebuy ↔ Asunción": "Piribebuy ↔ Paraguay rembiaporã",
  "Servicio de recolección": "Ñemono'õ rembiaporã",
  "Servicio urbano": "Táva rembiaporã",
  "Colectivos en circulación": "Kolektívo oguatáva",
  "Sentido del viaje": "Jeguata gotyo",
  IDA: "JEHO",
  "A Asunción": "Paraguay gotyo",
  VUELTA: "JEVY",
  "A Piribebuy": "Piribebuy gotyo",
  "buses en este sentido": "mba'yrumýi ko gotyo",
  "Frecuencia publicada por el operador": "Aravo jeyjey operador omyasãiva",
  "Próxima parada": "Pytaha oúva",
  "Zona actual": "Tenda ko'ag̃agua",
  "Llega en": "Og̃uahẽta",
  "Próxima zona en": "Tenda oúva",
  Distancia: "Mombyrykue",
  "ETA final": "Ñeg̃uahẽ paha",
  Velocidad: "Pya'ekue",
  "Ruta completada": "Tape ojejapopáva",
  "Atendido ✓": "Oñeñangarekopáma ✓",
  "Siguiendo vehículo": "Ojehapykuehohína mba'yrumýi",
  "Seguir vehículo": "Ehapykueho mba'yrumýi",
  "Usar mi ubicación": "Eiporu che renda",
  "El recolector ya pasó por el punto más cercano de la ruta.":
    "Ñemono'õha ohasáma tape renda hi'ag̃uivéva rupi.",
  "El recolector todavía no pasó por tu zona.":
    "Ñemono'õha ne'ĩra gueteri ohasa nde rupi.",
  "de ida a Asunción": "ohohína Paraguay gotyo",
  "de vuelta a Piribebuy": "ojevyhína Piribebuy gotyo",
  "La unidad ya pasó por el punto más cercano.":
    "Mba'yrumýi ohasáma tenda hi'ag̃uivéva rupi.",
  "Posición informada por GPS. Tu ubicación se procesa solo en este dispositivo.":
    "Renda GPS omomarandúva. Nde renda oñemboguata ko dispositivo-pe añoite.",
  "La ciudad, en movimiento y a la vista": "Táva oku'e ha ojehecha",
  "Seguí unidades y servicios municipales con posiciones GPS habilitadas sobre cartografía OpenStreetMap.":
    "Ehapykueho mba'yrumýi ha tavão rembiaporã GPS renda reheve OpenStreetMap yvy ra'angápe.",
  Transporte: "Mba'yrumýi",
  "Recorrido real": "Tape añetegua",
  "Geometría sobre calles, no líneas rectas.":
    "Tape ra'anga tape ári, ndaha'éi línea derecho.",
  "ETA dinámico": "Ñeg̃uahẽ aravo iñambuéva",
  "Se recalcula durante el movimiento.": "Oñepapa jey oguata aja.",
  "Experiencia ciudadana": "Tavaygua jeporu",
  "Información directa, sin paneles técnicos.": "Marandu hesakãva, panel técnica'ỹre.",
  "Administración · Movilidad": "Ñangareko · Jeguatapy",
  "Flota y telemetría": "Mba'yrumýi aty ha telemetría",
  "Posiciones recibidas desde los dispositivos GPS habilitados.":
    "Renda oñemog̃uahẽva umi GPS dispositivo oñemoneĩvagui.",
  "TIEMPO REAL": "ARAVO AÑETEGUA",
  Flota: "Mba'yrumýi aty",
  "Última posición válida informada por cada unidad.":
    "Peteĩteĩ mba'yrumýi renda paha oikovéva omomarandúva.",
  "km/h ·": "km/aravo ·",
  "Sin telemetría disponible": "Telemetría'ỹre",
  "Verificá el alta de unidades, códigos de seguimiento y dispositivos.":
    "Ehechajey mba'yrumýi ñemoĩ, tapykueho código ha dispositivo.",
  "Editor de rutas": "Tape mbosako'iha",
  "Administrá recorridos, paradas y zonas de cobertura desde un único espacio de trabajo.":
    "Eñangareko tape, pytaha ha tenda peteĩ mba'apo rendágui.",
  "rutas configuradas": "tape oñembosako'íva",
  "paradas y zonas": "pytaha ha tenda",
  "Seguimiento habilitado": "Tapykueho oñemoneĩva",
  "Act.:": "Ñembopyahu:",
  "Acá la historia aparece en el Santuario, en el museo, en la trama del poncho para’i y en los relatos que acompañan cada recorrido.":
    "Ko'ápe tembiasakue ojehecha Santuario-pe, museo-pe, poncho para'i ñandutípe ha mombe'ukuéra tape reheguápe.",
  "Servicios digitales disponibles": "Tembiaporã digitaal ojeporukuaáva",
  "Disponibilidad parcial de servicios": "Tembiaporã ojeporukuaa sapy'apy'a",
  "Foto:": "Ta'anga:",
  "Abogado y vecino de Piribebuy, Rodolfo Enmanuel Gini Orue encabeza la Intendencia Municipal y la coordinación de los servicios locales.":
    "Abogádo ha Piribebuy vecino, Rodolfo Enmanuel Gini Orue omotenonde Tavao Mburuvichaha ha omohenda tembiaporã ko'ápegua.",
  "Fuente:": "Ypy:",
  "Justicia Electoral": "Poravo Rekoporã",
  "Solo información": "Marandu añónte",
  Requerida: "Oñeikotevẽva",
  "No requerida": "Noñeikotevẽiva",
  "Ficha informativa": "Marandu kuatia",
  "— obligatorio": "— tekotevẽva",
  "Buscando…": "Ojehekahína…",
  Para: "G̃uarã",
  "Todo (": "Opavave (",
  "Agregá la referencia y el comprobante de la transferencia.":
    "Embojoapy transferencia rehegua marandu ha kuatiarechaukaha.",
  "Comprobante enviado. Tesorería verificará la acreditación.":
    "Kuatiarechaukaha oñemondo. Tesorería ohechajeyta jehepyme'ẽ.",
  "Mis pagos municipales": "Che tavão jehepyme'ẽ",
  "Obligaciones, comprobantes y recibos en un circuito trazable.":
    "Jehepyme'ẽrã, kuatiarechaukaha ha recibo peteĩ tape ojehapykuehokuaávape.",
  Actualizar: "Embopyahu",
  "Tu pago va a la cuenta oficial de la Municipalidad.":
    "Nde jehepyme'ẽ oho Tavao cuenta teépe.",
  "El portal municipal no recibe el dinero ni solicita datos de tarjeta. Los comprobantes son privados y cada acreditación queda auditada.":
    "Tavao rokẽ nomog̃uahẽi viru ha ndojeruréi tarjeta marandu. Kuatiarechaukaha ñemigua ha opa jehepyme'ẽ ojehechajey.",
  "Consultando obligaciones": "Ojehechahína jehepyme'ẽrã",
  "Resumen de pagos": "Jehepyme'ẽ mombykypyre",
  "Recibos emitidos": "Recibo oñeguenohẽva",
  Obligaciones: "Jehepyme'ẽrã",
  "El importe visible es siempre el saldo registrado por Tesorería.":
    "Viru ojehecháva ha'e pe saldo Tesorería omboheraguapýva.",
  "No tenés obligaciones registradas": "Ndereguerekói jehepyme'ẽrã oñemboheraguapýva",
  Importe: "Viru",
  Saldo: "Saldo",
  Vencimiento: "Arange paha",
  "Informar transferencia": "Emomarandu transferencia",
  "Comprobante privado": "Kuatiarechaukaha ñemigua",
  "Referencia bancaria": "Banco marandu",
  Comprobante: "Kuatiarechaukaha",
  "PDF, JPG, PNG o WebP. Máximo 10 MB.":
    "PDF, JPG, PNG térã WebP. Tuichakue paha 10 MB.",
  "Enviando…": "Oñemondohína…",
  "Enviar a verificación": "Emondo jehechajeyrã",
  "Movimientos y recibos": "Viru ñemýi ha recibo",
  "Ningún movimiento financiero se elimina.": "Ndojepe'ái mba'eveichagua viru ñemýi.",
  "Sin movimientos": "Ñemýi'ỹre",
  Canal: "Tape",
  Recibo: "Recibo",
  "No se pudo preparar el segundo factor. Volvé a intentarlo.":
    "Ndaikatúi oñembosako'i mokõiha ñemoañete. Eha'ãjey.",
  "El código no es válido o venció.": "Código ndoikói térã hi'ára opáma.",
  "Segundo factor confirmado": "Mokõiha ñemoañete oñemoañetéva",
  "Podés acreditar pagos durante esta sesión.":
    "Ikatu remoañete jehepyme'ẽ ko jeike aja.",
  "Confirmación reforzada requerida": "Oñeikotevẽ ñemoañete mbareteve",
  "Acreditar dinero exige un código de autenticación.":
    "Viru ñemoañete oikotevẽ jeike código.",
  "Preparando…": "Oñembosako'ihína…",
  "Confirmar segundo factor": "Emoañete mokõiha jeike",
  "Código QR para configurar la aplicación autenticadora":
    "QR código emoĩporã hag̃ua aplicación ñemoañeteha",
  "Escaneá el QR con tu aplicación autenticadora.":
    "Ehecha QR nde aplicación ñemoañeteha reheve.",
  "Código de 6 dígitos": "6 papapy código",
  "Verificando…": "Ojehechajeyhína…",
  Verificar: "Ehechajey",
  "Ingresá un importe válido en guaraníes.": "Emoinge viru guaraníme oikóva.",
  "Obligación emitida correctamente.": "Jehepyme'ẽrã oñeguenohẽ porãma.",
  "Indicá el número del comprobante de caja.": "Emoĩ caja kuatiarechaukaha papapy.",
  "Pago de caja registrado. Otra persona autorizada debe acreditarlo.":
    "Caja jehepyme'ẽ oñemboheraguapýma. Ambue tapicha oñemoneĩva omoañeteva'erã.",
  "Emisión, caja, verificación y recibos con doble control.":
    "Ñeguenohẽ, caja, jehechajey ha recibo mokõi control reheve.",
  "Acceso de consulta": "Jehecha jeike",
  "Tu rol puede consultar, pero no emitir ni acreditar pagos.":
    "Nde rol ikatu ohecha, hákatu ndaikatúi oguenohẽ ni omoañete jehepyme'ẽ.",
  "Cargando Tesorería": "Oñemyenyhẽhína Tesorería",
  "Nueva liquidación": "Liquidación pyahu",
  "Emitir obligación": "Eguenohẽ jehepyme'ẽrã",
  "El ciudadano debe poseer una cuenta verificada en este municipio.":
    "Tavaygua oguerekova'erã cuenta oñemoañetéva ko tavãope.",
  "Correo ciudadano": "Tavaygua ñe'ẽveve",
  Concepto: "Mba'e rehegua",
  "Importe en guaraníes": "Viru guaraníme",
  Detalle: "Marandu tuichakue",
  "Emitiendo…": "Oñeguenohẽhína…",
  "Obligaciones vigentes": "Jehepyme'ẽrã oikovéva",
  "Los pagos de caja también quedan sujetos a revisión independiente.":
    "Caja jehepyme'ẽ avei oha'ãrõ jehechajey ojueheguáva.",
  "Sin obligaciones": "Jehepyme'ẽrã'ỹre",
  Referencia: "Marandu",
  Ciudadano: "Tavaygua",
  "Registrar caja": "Emboheraguapy caja",
  "N.º comprobante": "Kuatiarechaukaha papapy",
  Registrar: "Emboheraguapy",
  "Bandeja de verificación": "Jehechajey ryru",
  "movimiento(s) pendientes.": "viru ñemýi oha'ãrõva.",
  "Bandeja al día": "Ryru ipyahúva",
  "Observación obligatoria": "Jehaipyre tekotevẽva",
  "Ver comprobante": "Ehecha kuatiarechaukaha",
  Rechazar: "Embotove",
  Acreditar: "Emoañete",
  "Hola,": "Mba'éichapa,",
  "Resumen de trámites": "Tembiaporã mombykypyre",
  "La ubicación se publica únicamente cuando existe telemetría vigente.":
    "Tenda oñemyasãi oĩ jave añoite telemetría oikovéva.",
  "Ver todas": "Ehecha opavave",
  "sin leer.": "oñemoñe'ẽ'ỹva.",
  "Buscar por número o asunto": "Eheka papapy térã mba'e rehegua rupive",
  "No hay resultados": "Ndaipóri ojejuhúva",
  "Todavía no hay trámites": "Ne'ĩra gueteri oĩ tembiaporã",
  "Sin derivar": "Noñemondóiva",
  "Indicá a quién representás.": "Emoĩ máva rérape reime.",
  "Esperá a que se carguen las dependencias y elegí una opción.":
    "Eha'ãrõ tavão vore oñemyenyhẽ ha eiporavo peteĩ.",
  "Ingresá el documento de la persona solicitante.": "Emoinge ojeruréva kuatia papapy.",
  "La dependencia seleccionada ya no está disponible.":
    "Tavão vore ojeporavóva ndojeporukuaavéima.",
  "Aceptá la declaración y el aviso de privacidad para presentar.":
    "Emoneĩ ñemombe'u ha ñemigua marandu emoinge hag̃ua.",
  "Guardar borrador": "Eñongatu hai pyre",
  "Progreso de la solicitud": "Jerure tenondeho",
  Solicitud: "Jerure",
  Revisión: "Jehechajey",
  "Los datos serán tratados conforme al aviso de privacidad.":
    "Marandu oñeñangarekóta ñemigua marandu he'iháicha.",
  "Guardado como": "Oñeñongatu",
  ". Dejá vacío para conservarlo.": ". Eheja nandi oñeñongatu hag̃ua.",
  "Actúo en representación de otra persona u organización.":
    "Amba'apo ambue tapicha térã aty rérape.",
  Representado: "Máva rérape",
  "Adjuntá solo la documentación requerida para tu solicitud.":
    "Embojoapy kuatia oñeikotevẽva nde jerurépe añoite.",
  "PDF, PNG, JPG o TXT · máx. 10 MB · hasta 5 archivos":
    "PDF, PNG, JPG térã TXT · tuichakue 10 MB · 5 kuatia peve",
  Quitar: "Eipe'a",
  "No agregaste archivos; en este trámite son opcionales.":
    "Nerembojoapýi kuatia; ko tembiaporãme ikatu oĩ térã nahániri.",
  "Archivo registrado": "Kuatia oñemboheraguapýva",
  "Registrando metadatos": "Oñemboheraguapyhína marandu joapy",
  "Subiendo archivo": "Ojehupihína kuatia",
  Pendiente: "Oha'ãrõva",
  "VISTA PREVIA": "JEHECHA TENONDEGUA",
  "Sin asunto": "Mba'e rehegua'ỹre",
  "Adjuntos nuevos": "Kuatia joapy pyahu",
  "Declaro que la información ingresada es correcta y puedo acreditarla.":
    "Amombe'u marandu amoingéva oĩ porãha ha ikatuha amoañete.",
  "Acepto el aviso de privacidad y el tratamiento de datos necesario para gestionar esta presentación.":
    "Amoneĩ ñemigua marandu ha umi dato oñeikotevẽva ko kuatia oñeñangareko hag̃ua.",
  Anterior: "Mboyvegua",
  "Presentando…": "Oñemoingehína…",
  "Presentar definitivamente": "Emoinge añetehápe",
  "Expediente no disponible": "Kuatiaryru ndojeporukuaái",
  "Descargar constancia": "Emboguejy kuatiarechaukaha",
  "Necesitamos una corrección": "Roikotevẽ ñemyatyrõ",
  "Explicá qué corregiste.": "Emyesakã mba'épa remyatyrõ.",
  "Adjuntar documentos de corrección": "Embojoapy ñemyatyrõ kuatiakuéra",
  "Enviar corrección": "Emondo ñemyatyrõ",
  "Sin asignar": "Oñeme'ẽ'ỹva",
  Versión: "Jehaipyre",
  "Autorizando…": "Oñemoneĩhína…",
  "No hay documentos.": "Ndaipóri kuatia.",
  "Contactá a Mesa de Entrada indicando el número de expediente.":
    "Eñe'ẽ Kuatia Ñemoguahẽha ndive ha emoĩ kuatiaryru papapy.",
  "Avisos generados por las acciones de tus expedientes.":
    "Marandu osẽva ne kuatiaryru rembiapokuéragui.",
  "Sin notificaciones": "Marandu pyahu'ỹre",
  "Validación inicial, correcciones y derivación trazable.":
    "Jehechajey tenondegua, ñemyatyrõ ha ñemondo ojehapykuehokuaáva.",
  "Abrir bandeja": "Eipe'a ryru",
  "Prioridad de atención": "Ñangareko tenondekue",
  "Expedientes nuevos y próximos a vencer.": "Kuatiaryru pyahu ha hi'ára opapotáva.",
  "Gestión institucional": "Tavão ñangareko",
  "Panel de administración": "Ñangareko panel",
  "Áreas disponibles para tu cuenta institucional.":
    "Vore ojeporukuaáva nde tavão cuenta-pe.",
  "Bandeja de expedientes": "Kuatiaryru ryru",
  "resultados según los filtros activos.": "ojejuhúva mboguaha oikovéva rupi.",
  "Número, asunto o ciudadano": "Papapy, mba'e rehegua térã tavaygua",
  "Buscar expediente": "Eheka kuatiaryru",
  Prioridad: "Tenondekue",
  "Todas las prioridades": "Opa tenondekue",
  Alta: "Yvate",
  "Cualquier responsable": "Oimeraẽ omba'apóva hese",
  "Asignados a mí": "Chéve oñeme'ẽva",
  "Vistas rápidas": "Jehecha pya'e",
  "La bandeja está vacía": "Ryru nandi",
  "Actuación registrada en el historial.": "Tembiapo oñemboheraguapy tembiasakuépe.",
  "Nota interna registrada.": "Kuatia hyepypegua oñemboheraguapýma.",
  "Prioridad actualizada con justificación.":
    "Tenondekue oñembopyahu mba'érepa reheve.",
  "Asignación reasignada con justificación.": "Ñeme'ẽ oñeme'ẽjey mba'érepa reheve.",
  "Volver a bandeja": "Ejevy ryrúpe",
  "Sin número": "Papapy'ỹre",
  Carátula: "Kuatiaryru akã",
  Ingreso: "Jeike",
  "Vencimiento orientativo": "Arange paha oñeimo'ãva",
  "Sin dependencia válida": "Tavão vore oikóva'ỹre",
  "Responsable actual": "Omba'apóva hese ko'ág̃a",
  "Sin asignación activa": "Ñeme'ẽ oikovéva'ỹre",
  "Documentos ciudadanos": "Tavaygua kuatiakuéra",
  Historial: "Tembiasakue",
  "Visible al ciudadano": "Tavaygua ohecháva",
  Interno: "Hyepypegua",
  "Sin actuaciones internas.": "Tembiapo hyepypegua'ỹre.",
  "Acciones permitidas": "Tembiapo oñemoneĩva",
  "Cada actuación es inmutable y queda registrada.":
    "Peteĩteĩ tembiapo ndaikatúi oñemoambue ha opyta oñemboheraguapy.",
  "Tomar expediente": "Ejapyhy kuatiaryru",
  "Reasignar a mi cuenta": "Emoĩjey che cuenta-pe",
  "Motivo u observación": "Mba'érepa térã jehaipyre",
  "Obligatorio para corregir, rechazar, liberar o priorizar.":
    "Tekotevẽ emyatyrõ, embotove, epoi térã emotenonde hag̃ua.",
  "Solicitar corrección": "Ejerure ñemyatyrõ",
  Admitir: "Emoneĩ",
  "Rechazar fundadamente": "Embotove mba'érepa reheve",
  "Liberar asignación": "Epoi ñeme'ẽgui",
  "Derivar a": "Emondo",
  "Seleccionar dependencia": "Eiporavo tavão vore",
  Derivar: "Emondo ambue vorépe",
  "Nueva prioridad": "Tenondekue pyahu",
  Baja: "Yvy",
  "Cambiar con justificación": "Emoambue mba'érepa reheve",
  "Nota interna": "Kuatia hyepypegua",
  "El ciudadano no puede verla.": "Tavaygua ndaikatúi ohecha.",
  Contenido: "Marandu",
  "Registrar nota": "Emboheraguapy kuatia",
  "Seguridad de la información": "Marandu tekorosã",
  "Información y funciones de la administración municipal.":
    "Tavão ñangareko marandu ha tembiaporã.",
  "Sin operaciones disponibles": "Tembiapo ojeporukuaáva'ỹre",
  "Verificando sesión": "Ojehechajeyhína jeike",
  "Ingresando…": "Ojeikehína…",
  "Revisá tu correo para confirmar la cuenta.":
    "Ehecha ne ñe'ẽveve remoañete hag̃ua cuenta.",
  "Si la cuenta existe, recibirá instrucciones.":
    "Oĩramo cuenta, og̃uahẽta chupe mba'éichapa ojapóta.",
  "Los textos alternativos en español y avañe’ẽ deben tener al menos 3 caracteres.":
    "Ta'anga jehaipyre castellano ha avañe'ẽme oguerekova'erã 3 tai térã hetave.",
  "Título en avañe’ẽ": "Teratee avañe'ẽme",
  "Categoría en avañe’ẽ": "Mba'e aty avañe'ẽme",
  "Resumen en avañe’ẽ": "Mombykypyre avañe'ẽme",
  "Texto completo en avañe’ẽ": "Jehaipyre tuichakue avañe'ẽme",
  "Texto alternativo en avañe’ẽ": "Jehaipyre ambuéva avañe'ẽme",
  "Antetítulo en avañe’ẽ": "Teratee mboyvegua avañe'ẽme",
  "Biografía del Intendente en avañe’ẽ": "Tavao ruvicha rekove mombe'u avañe'ẽme",
  "Texto de bienvenida en avañe’ẽ": "Ñemog̃uahẽ jehaipyre avañe'ẽme",
  "Cargo en avañe’ẽ": "Cargo avañe'ẽme",
  "Bancada o afiliación en avañe’ẽ": "Aty térã joaju avañe'ẽme",
  "Nombre de la fuente en avañe’ẽ": "Ypy réra avañe'ẽme",
  "Nombre en avañe’ẽ": "Téra avañe'ẽme",
  "Descripción breve en avañe’ẽ": "Mombe'u mbyky avañe'ẽme",
  "Ubicación o zona en avañe’ẽ": "Tenda térã tekoha avañe'ẽme",
  "Santuario Nacional Dulce Nombre de Jesús – Ñandejára Guasu":
    "Santuario Nacional Dulce Nombre de Jesús – Ñandejára Guasu",
  "Museo Histórico Comandante Pedro Pablo Caballero":
    "Comandante Pedro Pablo Caballero Tembiasakue Róga",
  "Monumento Hospital de Sangre": "Tuguy Tasyo Mandu'arã",
  "Paseo de la Memoria": "Mandu'a Rape",
  "Piscina Municipal": "Tavao Ysyry Renda",
  "Itá Cajón": "Itá Cajón",
  "Salto Amambay": "Salto Amambay",
  "Salto Piraretã": "Salto Piraretã",
  "Cascada de Chololó": "Chololó Ytororõ",
  "Mirador del Oratorio del Cerro San Rafael": "Cerro San Rafael Oratorio Jehechaha",
  "Poncho Rogá y el Poncho Para’i de 60 Listas":
    "Poncho Rogá ha Poncho Para'i 60 Listas",
  "Ruta de la Caña Paraguaya": "Paraguái Kaguy Rape",
  "Templo histórico profundamente ligado a la identidad religiosa, cultural y patrimonial de Piribebuy.":
    "Tupão ymaguare ojoaju mbaretéva Piribebuy jerovia, arandupy ha mba'e teéva ndive.",
  "Museo municipal que conserva objetos y testimonios de la historia local y hoy alberga el Centro de Interpretación del Poncho Para’i.":
    "Tavao museo oñongatúva táva rembiasakue mba'ekuéra ha ko'ág̃a oguerekóva Poncho Para'i Ñemyesakã Renda.",
  "Sitio de memoria que recuerda uno de los episodios más dolorosos de la Batalla de Piribebuy.":
    "Mandu'a renda omomandu'áva Piribebuy Ñorairõ mba'asy tuichavéva.",
  "Recorrido urbano dedicado a preservar y comunicar la memoria histórica de la ciudad heroica.":
    "Táva rape oñongatu ha omombe'úva táva py'aguasu rembiasakue.",
  "Espacio natural acondicionado sobre el arroyo Piribebuy, cercano al centro y rodeado de vegetación.":
    "Tekoha oñembosako'íva Piribebuy ysyry ári, táva mbyte ypýpe ha ka'avo apytépe.",
  "Tramo del arroyo Piribebuy que corre entre grandes formaciones de piedra y pequeñas cascadas.":
    "Piribebuy ysyry vore ohasáva ita guasu ha ytororõ michĩ apytépe.",
  "Caída de agua y entorno natural ubicado a pocos kilómetros del centro de la ciudad.":
    "Ytororõ ha tekoha opytáva táva mbytégui sa'i mombyry.",
  "Cascada rodeada de monte y formaciones rocosas en uno de los paisajes más reconocidos del distrito.":
    "Ytororõ ka'aguy ha ita apytépe, peteĩ distrito tekoha ojekuaavéva.",
  "Área de cascadas y vegetación sobre la ruta que conecta Piribebuy con Itacurubí.":
    "Ytororõ ha ka'avo renda Piribebuy ha Itacurubí rape ári.",
  "Mirador elevado que integra paisaje, espiritualidad y vistas del entorno cordillerano.":
    "Jehechaha yvate ombojoajúva tekoha, jerovia ha Cordillera jehecha.",
  "Espacio vinculado con la transmisión del conocimiento artesanal que distingue a Piribebuy.":
    "Tenda oñembohasa hag̃ua pópe guare arandu ombojoavýva Piribebuy-pe.",
  "Circuito productivo y cultural para conocer la tradición cañera y su relación con el territorio.":
    "Tembiapo ha arandupy rape ojeikuaa hag̃ua kaguy apo yma ha ijokuái yvy ndive.",
  "Zona histórica de Piribebuy": "Piribebuy rembiasakue renda",
  "Zona urbana de Piribebuy": "Piribebuy táva renda",
  "Aguas arriba de la Piscina Municipal": "Tavao Ysyry Rendágui yvate gotyo",
  "Compañía Tape Guasu": "Tape Guasu compañía",
  "Colonia Piraretã": "Piraretã colonia",
  "Ruta Piribebuy–Itacurubí": "Piribebuy–Itacurubí rape",
  "Cerro San Rafael": "Cerro San Rafael",
  "Distrito de Piribebuy": "Piribebuy distrito",
  "Piribebuy participó de las elecciones municipales de 2026":
    "Piribebuy oike 2026 tavão jeporavópe",
  "La ciudadanía participó de la jornada electoral del 4 de octubre para elegir a sus autoridades municipales.":
    "Tavayguakuéra oike jasypa 4 jeporavo árape oiporavo hag̃ua tavão mburuvichakuéra.",
  "El domingo 4 de octubre se desarrollaron las elecciones municipales de 2026. Tras el cierre de la votación y el escrutinio público, la Justicia Electoral habilitó el sistema TREP para consultar resultados preliminares y no vinculantes. Los resultados oficiales corresponden al posterior juzgamiento, cómputo y proclamación de los Tribunales Electorales.":
    "Arateĩ jasypa 4-pe ojejapo 2026 tavão jeporavo. Jeporavo oñemboty ha voto ojepapa rire, Poravo Rekoporã oipe'a TREP resultado tenondegua ojehecha hag̃ua. Resultado tee oúva tribunal jepapa ha ñemoherakuã rire.",
  Ciudad: "Táva",
  "Avanza la digitalización de trámites en el Juzgado de Paz de Piribebuy":
    "Piribebuy Juzgado de Paz rembiaporã digitaal oñemotenonde",
  "El Juzgado de Paz incorporó la firma electrónica cualificada para los permisos de viaje de niños, niñas y adolescentes.":
    "Juzgado de Paz omoinge firma electrónica cualificada mitãnguéra jeguata ñemoneĩme.",
  "El Juzgado de Paz de Piribebuy actualizó el procedimiento para tramitar permisos de viaje de niños, niñas y adolescentes. La herramienta permite al magistrado firmar digitalmente los formularios e incorporar un código QR para verificar el documento, reduciendo pasos posteriores de legalización de firmas.":
    "Piribebuy Juzgado de Paz ombopyahu mitã ha mitãrusu jeguata ñemoneĩ rape. Tembiporu oheja juez ofirma digitaal ha omoinge QR código kuatia oñemoañete hag̃ua.",
  Servicios: "Tembiaporã",
  "Continúan los avances en las obras de la Escuela Profesora Limpia Pérez":
    "Profesora Limpia Pérez Mbo'ehao ñemopu'ã oñemotenonde",
  "La construcción de la Escuela N.º 259 registró un avance general superior al 60 % a finales de septiembre.":
    "Mbo'ehao N.º 259 ñemopu'ã ohasa 60 % jasyporundy pahápe.",
  "Las obras de la Escuela N.º 259 Profesora Limpia C. Pérez superaron el 60 % de ejecución general, según la información publicada el 28 de septiembre. El proyecto incluye pabellones, espacios recreativos, circulación interna y un polideportivo para la comunidad educativa de Piribebuy.":
    "Mbo'ehao N.º 259 Profesora Limpia C. Pérez ñemopu'ã ohasa 60 %, marandu oñemyasãiva jasyporundy 28-pe he'iháicha. Tembiapo oguereko mbo'ehao vore, ñembosarái renda, tape hyepypegua ha polideportivo Piribebuy mbo'ehao atýpe g̃uarã.",
  Educación: "Tekombo'e",
  "Dependencia municipal guardada y registrada en auditoría.":
    "Tavao vore oñeñongatu ha ojehai jehechajey rembiasápe.",
  "Registro de áreas municipales": "Tavao vorekuéra jehai",
  "Cada alta o modificación queda identificada con responsable, fecha y motivo.":
    "Opa jehai pyahu térã ñemoambue opyta mávapa ojapo, arange ha mba'érepa ndive.",
  "A confirmar": "Oñemoneĩva'erã",
  "Registrar dependencia": "Ehai tavão vore",
  "Configurá el área responsable y sus datos de atención.":
    "Emohenda vore oñangarekóva ha iñangareko rehegua marandu.",
  "Nombre oficial": "Téra tee",
  "Nombre breve": "Téra mbyky",
  "Función de la dependencia": "Tavao vore rembiapo",
  "Teléfono institucional": "Tavao pumbyry",
  "Correo institucional": "Tavao ñe'ẽveve",
  "Guardar dependencia": "Eñongatu tavão vore",
  "Alta de dependencia municipal.": "Tavao vore pyahu jehai.",
  "Control institucional": "Tavao ñangareko",
  "Auditoría municipal": "Tavao jehechajey",
  "Historial de expedientes, dependencias, personal, roles, trámites y contenidos.":
    "Kuatia, tavão vore, mba'apohára, tembiapo tee ha marandu rembiasakue.",
  "Historial protegido": "Tembiasakue oñeñangarekóva",
  "Resumen de auditoría": "Jehechajey mombyky",
  "Total encontrado": "Ojejuhúva tuichakue",
  "Personas en esta vista": "Tapichakuéra ko jehechahápe",
  "Últimas 24 horas": "24 aravo ohasava'ekuépe",
  "Búsqueda y control": "Jeheka ha ñangareko",
  "Filtrar actuaciones": "Eiporavo tembiapokuéra",
  "Persona, expediente, acción o dependencia":
    "Tapicha, kuatia, tembiapo térã tavão vore",
  "Todas las dependencias": "Opa tavão vore",
  Desde: "Guive",
  Hasta: "Peve",
  "Aplicar filtros": "Eiporu poravorã",
  Limpiar: "Emopotĩ",
  "Categorías de auditoría": "Jehechajey atykuéra",
  "Cargando historial de auditoría": "Jehechajey rembiasakue oñemyenyhẽhína",
  "No hay actuaciones para esta vista": "Ndaipóri tembiapo ko jehechahápe",
  "Cambiá los filtros para consultar otro período o categoría.":
    "Emoambue poravorã ehecha hag̃ua ambue ára térã aty.",
  "Actuaciones registradas": "Tembiapokuéra ojehaíva",
  "Se muestran las": "Ojehechauka",
  "actuaciones más recientes de": "tembiapo ipyahuvéva, ko'ãva apytégui:",
  ". Usá los filtros para acotar la búsqueda.":
    ". Eiporu poravorã emomichĩ hag̃ua jeheka.",
  "Rol al registrar": "Tembiapo tee ojehai jave",
  Expediente: "Kuatia rape",
  "Registro afectado": "Jehai oñemoambuéva",
  "Detalle de la actuación": "Tembiapo marandu",
  Auditoría: "Jehechajey",
  "Personal y roles": "Mba'apohára ha tembiapo tee",
  "Borrador de expediente guardado": "Kuatia rape apopyrã oñeñongatu",
  "Solicitud presentada": "Jerure oñemoinge",
  "Expediente recibido en Mesa de Entrada": "Kuatia rape oñeg̃uahẽ Kuatia Ñemoguahẽhápe",
  "Expediente liberado": "Kuatia rape ojepoíva",
  "Corrección solicitada": "Ñemyatyrõ ojejerure",
  "Corrección recibida": "Ñemyatyrõ oñeg̃uahẽ",
  "Presentación rechazada": "Jerure oñemboyke",
  "Expediente derivado": "Kuatia rape oñembohasa",
  "Procesamiento iniciado": "Tembiapo oñepyrũ",
  "Expediente resuelto": "Kuatia rape oñembohovái",
  "Expediente archivado": "Kuatia rape oñeñongatu",
  "Expediente cancelado": "Kuatia rape oñembogue",
  "Expediente reasignado": "Kuatia rape oñeme'ẽ jey ambuépe",
  "Prioridad de expediente modificada": "Kuatia rape tenondegua oñemoambue",
  "Nota interna agregada": "Marandu hyepypegua oñembojoapy",
  "Asignación de personal creada": "Mba'apohára rembiapo oñemoĩ",
  "Asignación de personal finalizada": "Mba'apohára rembiapo oñemohu'ã",
  "Cargo municipal guardado": "Tavao mba'apo oñeñongatu",
  "Rol asignado a una persona": "Tembiapo tee oñeme'ẽ tapichápe",
  "Rol revocado": "Tembiapo tee ojepe'a",
  "Rol reactivado": "Tembiapo tee oñemyendy jey",
  "Asignación de rol actualizada": "Tembiapo tee ñeme'ẽ oñembopyahu",
  "Asignación de rol eliminada": "Tembiapo tee ñeme'ẽ oñembogue",
  "Dependencia registrada": "Tavao vore ojehai",
  "Dependencia actualizada": "Tavao vore oñembopyahu",
  "Dependencia desactivada": "Tavao vore oñembogue sapy'a",
  "Dependencia reactivada": "Tavao vore oñemyendy jey",
  "Dependencia eliminada": "Tavao vore oñembogue",
  "Datos de una persona actualizados": "Tapicha marandu oñembopyahu",
  "Registro de persona eliminado": "Tapicha jehai oñembogue",
  "Trámite registrado": "Tembiaporã ojehai",
  "Trámite actualizado": "Tembiaporã oñembopyahu",
  "Trámite eliminado": "Tembiaporã oñembogue",
  "Versión de trámite creada": "Tembiaporã jehaipyre pyahu ojejapo",
  "Ficha de trámite actualizada": "Tembiaporã marandu oñembopyahu",
  "Versión de trámite eliminada": "Tembiaporã jehaipyre oñembogue",
  "Requisito de trámite agregado": "Tembiaporã mba'e oikotevẽva oñembojoapy",
  "Requisito de trámite actualizado": "Tembiaporã mba'e oikotevẽva oñembopyahu",
  "Requisito de trámite eliminado": "Tembiaporã mba'e oikotevẽva oñembogue",
  "Visibilidad de sección modificada": "Vore jehecha oñemoambue",
  "Panel ejecutivo consultado": "Mburuvicha panel ojehecha",
  "Cuenta propietaria habilitada": "Jára cuenta oñemyendy",
  "Contenido creado": "Marandu ojejapo",
  "Contenido actualizado": "Marandu oñembopyahu",
  "Contenido eliminado": "Marandu oñembogue",
  Personal: "Mba'apohára",
  Asignación: "Tembiapo ñeme'ẽ",
  "Rol de usuario": "Puruhára rembiapo tee",
  "Sección del portal": "Tavão rokẽ vore",
  "Ficha de trámite": "Tembiaporã marandu",
  Requisito: "Oñeikotevẽva",
  "Imagen del portal": "Tavão rokẽ ra'anga",
  "Contenido público": "Opavavépe g̃uarã marandu",
  Concejal: "Tavao atyguasu pehẽngue",
  "Lugar turístico": "Jehechaha renda",
  "Panel ejecutivo": "Mburuvicha panel",
  Superadministrador: "Ñangarekoha guasu",
  "Administrador municipal": "Tavao ñangarekoha",
  Intendente: "Tavao mburuvicha",
  "Administrador técnico": "Teknología ñangarekoha",
  "Agente de Mesa de Entrada": "Kuatia Ñemoguahẽha mba'apohára",
  "Supervisor de Mesa de Entrada": "Kuatia Ñemoguahẽha mburuvicha",
  "Agente de dependencia": "Tavao vore mba'apohára",
  "Jefatura de dependencia": "Tavao vore mburuvicha",
  "Acceso a la información": "Marandu jeike",
  Auditor: "Jehechajeyhára",
  "Consulta ejecutiva": "Mburuvicha jehecha",
  "Operador de movilidad": "Jeguatapy mba'apohára",
  "Edición académica": "Mbo'ehao marandu ñemyatyrõ",
  Estudiante: "Temimbo'e",
  "Acceso de estudiantes": "Temimbo'e jeike",
  "Asignar rol de estudiante": "Eme'ẽ temimbo'e rembiapo",
  "Elegí una cuenta ciudadana ya registrada.":
    "Eiporavo peteĩ tavaygua cuenta ojehaimava'ekue.",
  "· estudiante": "· temimbo'e",
  "Academia habilitada": "Mbo'ehao oñemyendy",
  "Sólo portal ciudadano": "Tavaygua rokẽ añónte",
  "Motivo para auditoría": "Mba'érepa ojejapo, jehechajeyrã",
  "Retirar acceso de estudiante": "Eipe'a temimbo'e jeike",
  "Habilitar como estudiante": "Emyendy temimbo'e ramo",
  "Tu acceso permite revisar estudiantes, pero no asignar el rol.":
    "Nde jeike oheja rehecha temimbo'ekuéra, hákatu ndikatúi reme'ẽ upe rembiapo.",
  "Recomendado: 1200 × 675 px (16:9), hasta 10 MB. Los archivos JPG y PNG se convierten automáticamente a WebP.":
    "Oñemoñe'ẽ: 1200 × 675 px (16:9), 10 MB peve. JPG ha PNG oñemoambue ijehegui WebP-pe.",
  "Foto tipo carné (recomendado: 1200 × 1200 px, formato 1:1)":
    "Karné ra'anga (oñemoñe'ẽ: 1200 × 1200 px, 1:1)",
  "JPG, PNG o WebP, hasta 10 MB. JPG y PNG se convierten automáticamente a WebP. Usá el rostro centrado y dejá un margen uniforme alrededor para que calce en el cuadrado.":
    "JPG, PNG térã WebP, 10 MB peve. JPG ha PNG oñemoambue ijehegui WebP-pe. Emoĩ tova mbytépe ha eheja peteĩcha pe margen ijerére oike porã hag̃ua pe cuadrado-pe.",
  "Fotografía (recomendado: 1200 × 800 px, formato 3:2)":
    "Ta'anga (oñemoñe'ẽ: 1200 × 800 px, 3:2)",
  "JPG, PNG o WebP, hasta 10 MB. JPG y PNG se convierten automáticamente a WebP. Mantené el motivo principal centrado.":
    "JPG, PNG térã WebP, 10 MB peve. JPG ha PNG oñemoambue ijehegui WebP-pe. Eguereko ta'anga tenondegua mbytépe.",
  "Imagen (recomendado: 1600 × 900 px, formato 16:9)":
    "Ta'anga (oñemoñe'ẽ: 1600 × 900 px, 16:9)",
  "JPG o WebP, hasta 10 MB. Evitá texto pegado a los bordes.":
    "JPG térã WebP, 10 MB peve. Ani emoĩ jehaipyre pe rembe'y ypýpe.",
  "JPG, PNG o WebP, hasta 10 MB. JPG y PNG se convierten automáticamente a WebP. Evitá texto o rostros pegados a los bordes para que la imagen se adapte bien a celulares.":
    "JPG, PNG térã WebP, 10 MB peve. JPG ha PNG oñemoambue ijehegui WebP-pe. Ani emoĩ jehaipyre térã tova rembe'y ypýpe, ta'anga oike porã hag̃ua pumbyrýpe.",
  "Ubicación — Moõpa opyta": "Moõpa opyta",
  "Cómo llegar": "Mba'éichapa aguahẽta",
  "Ver en Google Maps": "Ehecha Google Maps-pe",
  "¡Parece que te perdiste por Piribebuy!": "Ha'ete okañyha ndehegui Piribebuy-pe!",
  "La página que buscás no existe o cambió de ubicación.":
    "Pe kuatiarogue rehekáva ndaipóri térã ova ambue hendápe.",
  "Volver al inicio": "Ejevy ñepyrũme",
  "Volver atrás": "Ejevy tapykue",
  "Ruta no encontrada": "Tape ndojejuhúi",
  "Explorando Piribebuy...": "Jaikuaave Piribebuy...",
  "Cerrar aviso": "Emboty marandu",
  "Ficha y fotografía oficial": "Marandu ha ta'anga tee",
  "Fotografía oficial del intendente": "Tavao Mburuvicha ra'anga tee",
  "Guardar textos": "Eñongatu jehaipyrekuéra",
  "Cambiar fotografía": "Emoambue ta'anga",
  "Eliminar fotografía": "Embogue ta'anga",
  "Guardar encuadre": "Eñongatu ta'anga ñemohenda",
  "Intervalo automático del carrusel": "Ta'anga ñemoambue aravo",
  "Guardar intervalo": "Eñongatu aravo",
  "Título en español": "Teratee castellano-pe",
  "Descripción en español": "Mombe'u castellano-pe",
  "Descripción en avañe’ẽ": "Mombe'u avañe’ẽme",
  "Orden de aparición": "Jehechauka ñemohenda",
  "Visible públicamente": "Ojehecha opavavépe",
  "Hacé clic en el mapa o arrastrá el marcador para ajustar el punto.":
    "Eikutu mapa-pe térã egueraha techaukaha emohenda hag̃ua tenda.",
  "Administración 2026–2031": "Ñesãmbyhy 2026–2031",
  "Jaikuaave Piribebuy...": "Jaikuaave Piribebuy...",
  "Cerrar confirmación": "Emboty ñemoneĩ",
  "Acción sensible": "Tembiapo oñeñangarekóva",
  Confirmación: "Ñemoneĩ",
  "Confirmar cambios": "Emoneĩ ñemoambue",
  "Sí, aplicar cambios": "Héẽ, emoĩ ñemoambue",
  "Enlace copiado.": "Joajuha oñembokuatia.",
  "Copiar o compartir enlace": "Embohasa térã emoherakuã joajuha",
  "Espacio preparado para fotografías institucionales de Piribebuy":
    "Tenda oñembosako'íva Piribebuy ta'anga teépe g̃uarã",
  "Imágenes de Piribebuy": "Piribebuy ra'angakuéra",
  "Imágenes institucionales de Piribebuy": "Piribebuy ta'anga teekuéra",
  "Controles del carrusel": "Ta'anga ñemýi ñesãmbyhy",
  "Imagen anterior": "Ta'anga mboyvegua",
  "Elegir imagen": "Eiporavo ta'anga",
  "Imagen siguiente": "Ta'anga upeigua",
  "Una Municipalidad presente, clara y accesible":
    "Tavao oĩva, hesakãva ha opavavépe g̃uarã",
  "Catálogo de trámites": "Tembiaporã rysýi",
  "Confirmar dependencia": "Emoneĩ tavao vore",
  "Se guardarán los datos de esta dependencia municipal.":
    "Ko tavao vore marandu oñeñongatúta.",
  "Confirmar cargo": "Emoneĩ tembiapo",
  "Se guardará este cargo en la estructura municipal.":
    "Ko tembiapo oñeñongatúta tavao ñemohendápe.",
  "Confirmar asignación": "Emoneĩ ñeme'ẽ",
  "La persona recibirá el cargo, rol y funciones seleccionados.":
    "Tapicha ohupytýta tembiapo, tembiaporã ha hembiaporã ojeporavóva.",
  "Se revocarán el cargo y los accesos vinculados a esta asignación.":
    "Ojepe'áta tembiapo ha jeikeha ko ñeme'ẽ rehegua.",
  "Foto 1 de la portada": "Rogue ta'anga 1",
  "Primera imagen que verá la ciudadanía al ingresar.":
    "Ta'anga peteĩha tavayguakuéra ohechátava oike jave.",
  "Foto 2 de la portada": "Rogue ta'anga 2",
  "Se mostrará automáticamente después de la primera.":
    "Ojehechaukáta ijehegui peteĩha rire.",
  "Foto 3 de la portada": "Rogue ta'anga 3",
  "Tercera posición del recorrido fotográfico.": "Ta'anga jeguata renda mbohapyha.",
  "Foto 4 de la portada": "Rogue ta'anga 4",
  "Cuarta posición opcional del carrusel.": "Ta'anga ñemýi renda irundyha ikatúva.",
  "Foto 5 de la portada": "Rogue ta'anga 5",
  "Quinta posición opcional del carrusel.": "Ta'anga ñemýi renda poha ikatúva.",
  "Foto de Historia e identidad": "Tembiasakue ha teko tee ra'anga",
  "Reemplaza el gráfico que aparece junto al bloque cultural.":
    "Omyengovia ta'anga oĩva arandupy vore ykére.",
  "Hay cambios sin guardar": "Oĩ ñemoambue noñeñongatúiva",
  "Si continuás, se descartarán las modificaciones del formulario actual.":
    "Rehojeýramo, oñemboykéta ko'ág̃agua ñemoambue.",
  "No se pudo completar la operación": "Ndaikatúi oñemohu'ã tembiapo",
  "Completá latitud y longitud juntas, o dejá ambas vacías.":
    "Emyenyhẽ latitud ha longitud oñondive, térã eheja mokõivéva nandi.",
  "Ingresá un enlace HTTPS válido de Google Maps.":
    "Emoinge Google Maps joajuha HTTPS oikóva.",
  "Contenidos e imágenes": "Marandu ha ta'angakuéra",
  "Fotos del inicio": "Ñepyrũ ra'angakuéra",
  "Diseño del portal": "Tavão rogue ñemohenda",
  "Fuentes, logos y fotos del inicio": "Tai, logo ha ñepyrũ ta'angakuéra",
  "Identidad institucional": "Tavao rekotee",
  "Administrá por separado las fuentes, los logotipos y las fotografías públicas sin alterar los demás contenidos.":
    "Eñangareko tai, logo ha ta'anga opavavépe ojehecháva rehe peteĩteĩ, ambue marandu emoambue'ỹre.",
  "Tipografía institucional": "Tavao tai ñemohenda",
  "Elegí un estilo independiente para títulos, subtítulos y cuerpo.":
    "Eiporavo tai reko ijeheguíva teratee, teratee'i ha jehaipyre rehe.",
  "Fuentes locales y seguras": "Tai ko'ápeguáva ha hekorosãva",
  "Títulos principales": "Teratee tenondegua",
  "Subtítulos y destacados": "Teratee'i ha ojehechaukavéva",
  "Orgullo que nos une": "Ñande orgullo ñanembojoajúva",
  "Piribebuy Digital · Gobierno Municipal": "Piribebuy Digital · Tavao Rekuái",
  "Nuestra historia mira al futuro.": "Ñane rembiasakue omaña tenonderã.",
  "Piribebuy honra su historia mirando hacia adelante. Este portal nace para incorporar tecnología a la gestión municipal, acercar servicios e información pública y construir una Municipalidad más ágil, transparente y cercana a cada barrio y compañía.":
    "Piribebuy omomba'e hembiasakue ha omaña tenonderã. Ko portal heñói omoinge hag̃ua tembipurupyahu tavao ñesãmbyhýpe, omboja hag̃ua tavayguáre tembiaporã ha marandu opavavépe g̃uarã, ha omopu'ã hag̃ua peteĩ Tavao Rekuái pya'eve, hesakãve ha hi'ag̃uivéva barrio ha compañía peteĩteĩme.",
  "Cuerpo y lectura": "Jehaipyre ha ñemoñe'ẽ",
  "Información clara y servicios accesibles para la ciudadanía.":
    "Marandu hesakãva ha tembiaporã tavayguakuérape g̃uarã.",
  "Guardar tipografías": "Eñongatu tai ñemohenda",
  "Logotipos del portal": "Tavão rogue logokuéra",
  "El header y la pantalla de carga conservan archivos independientes.":
    "Rogue akã ha ñemyenyhẽ jehechaha oguereko vore ijeheguíva.",
  "Logo del header": "Rogue akã logo",
  "Se muestra junto al nombre del Gobierno Municipal.":
    "Ojehechauka Tavao Rekuái réra ykére.",
  "Logo de carga": "Ñemyenyhẽ logo",
  "Aparece durante la carga inicial y de rutas principales.":
    "Ojehechauka ñepyrũ ha tape tenondegua henyhẽ jave.",
  Cargado: "Oñemoinge",
  "Sin logo": "Logo'ỹre",
  "Cambiar logo": "Emoambue logo",
  "Subir logo": "Emoinge logo",
  "Fotografías del inicio": "Ñepyrũ ta'angakuéra",
  "Carrusel principal e Historia e identidad.":
    "Ta'anga ñemýi tenondegua ha Tembiasakue ha teko tee.",
  "Montserrat · sólida y moderna": "Montserrat · hatã ha ko'ág̃agua",
  "Inter · clara y contemporánea": "Inter · hesakã ha ko'ág̃agua",
  "Libre Baskerville · institucional": "Libre Baskerville · tavao rehegua",
  "Cormorant Garamond · editorial": "Cormorant Garamond · kuatiahaipyre reko",
  "Carrusel y sección inferior": "Ta'anga ñemýi ha vore iguypegua",
  "sin fecha": "arange'ỹre",
  Ver: "Ehecha",
  "Nuevo concejal": "Concejal pyahu",
  "Enlace de Google Maps": "Google Maps joajuha",
  "Inicio del portal": "Rokẽ ñepyrũ",
  "Cargá por separado las imágenes de la portada y la fotografía de Historia e identidad.":
    "Emoinge ijehegui rogue ta'angakuéra ha Tembiasakue ha teko tee ra'anga.",
  "Cargar fotografía": "Emoinge ta'anga",
  "Espacios fotográficos del inicio": "Ñepyrũ ta'anga rendakuéra",
  "Carrusel de portada": "Rogue ta'anga ñemýi",
  "Con dos o más fotos, el desplazamiento automático se activa solo.":
    "Mokõi térã hetave ta'angándi, ñemýi ijehegui oñepyrũ.",
  "Recomendado: 1600 × 900 px": "Oñemoñe'ẽ: 1600 × 900 px",
  Cargada: "Oñemoinge",
  "Sin foto": "Ta'anga'ỹre",
  "Medida recomendada:": "Tuichakue oñemoñe'ẽva:",
  "Reemplazar foto": "Emyengovia ta'anga",
  "Cargar foto": "Emoinge ta'anga",
  "Ubicación de la fotografía": "Ta'anga renda",
  "Fotografía (recomendado:": "Ta'anga (oñemoñe'ẽ:",
  "Ej.: Vista panorámica del centro de Piribebuy":
    "Techapyrã: Piribebuy mbyte jehecha tuicháva",
  "Foco horizontal": "Jehecha hysýiva",
  "Foco vertical": "Jehecha yvate gotyo",
  "Crédito o autor (opcional)": "Apohára réra (ikatu'ỹva)",
  "Publicar fotografía": "Emyasãi ta'anga",
  "Ver biblioteca visual completa (": "Ehecha ta'anga renda tuichakue (",
  "Publicar ficha del Intendente": "Emyasãi Tavao Mburuvicha marandu",
  "Se actualizarán únicamente los textos institucionales.":
    "Tavao jehaipyrekuéra añoite oñembopyahúta.",
  "Ficha actualizada": "Marandu oñembopyahu",
  "Los textos del Intendente ya están publicados.":
    "Tavao Mburuvicha jehaipyre oñemyasãima.",
  "No se pudo guardar": "Ndaikatúi oñeñongatu",
  "Seleccioná una fotografía": "Eiporavo peteĩ ta'anga",
  "Actualizar fotografía oficial": "Embopyahu ta'anga tee",
  "Fotografía actualizada": "Ta'anga oñembopyahu",
  "No se pudo actualizar la fotografía": "Ndaikatúi oñembopyahu ta'anga",
  "Eliminar fotografía oficial": "Embogue ta'anga tee",
  "La ficha conservará sus textos y mostrará el recurso institucional de reemplazo.":
    "Marandu oñeñongatúta ha ojehechaukáta ta'anga renda tee.",
  "Fotografía eliminada": "Ta'anga oñembogue",
  "No se pudo eliminar la fotografía": "Ndaikatúi oñembogue ta'anga",
  "Cargando ficha del Intendente": "Oñemyanyhẽ Tavao Mburuvicha marandu",
  "Textos y fotografía se publican de manera independiente.":
    "Jehaipyre ha ta'anga oñemyasãi ijehegui.",
  "Información institucional": "Tavao marandu",
  "El encuadre es no destructivo: conserva la fotografía original y ajusta su posición visual.":
    "Ta'anga ñemohenda nombyaíri: oñongatu ypykue ha omohenda jehecha.",
  "Vista previa del retrato": "Ta'anga jehecha mboyve",
  "Sin fotografía": "Ta'anga'ỹre",
  "Subir o cambiar fotografía (JPG, PNG o WebP)":
    "Emoinge térã emoambue ta'anga (JPG, PNG térã WebP)",
  "Posición horizontal del rostro": "Tova renda hysýiva",
  "Posición vertical del rostro": "Tova renda yvate gotyo",
  Latitud: "Latitud",
  Longitud: "Longitud",
  "Selector visual de ubicación turística": "Jeheguata renda jehecháva poravoha",
  "El mapa no pudo cargarse. Podés ingresar las coordenadas manualmente.":
    "Mapa ndaikatúi oñemyanyhẽ. Ikatu emoinge coordenada nde po rupive.",
  "Confirmar actuación": "Emoneĩ tembiapo",
  "La actuación se incorporará al historial permanente del expediente.":
    "Tembiapo oñemoĩta expediente rembiasakue opytávape.",
  "Registrar nota interna": "Ehai marandu hyepypegua",
  "La nota quedará incorporada al expediente y no será visible al ciudadano.":
    "Marandu opytáta expediente-pe ha tavaygua ndohechamo'ãi.",
  "Cambiar prioridad": "Emoambue tenondekue",
  "Reasignar expediente": "Embohasa expediente",
  "El expediente quedará asignado a tu cuenta y el cambio se auditará.":
    "Expediente opytáta nde rérape ha ñemoambue oñehesa'ỹijóta.",
  "Maquinarias sin posición publicada": "Mba'yrumýi renda noñemyasãiva",
  "Las maquinarias aparecerán aquí únicamente cuando cuenten con telemetría municipal real y habilitada.":
    "Mba'yrumýi ojehechaukáta ko'ápe oguerekóramo telemetría tavao tee ha oñembohapéva.",
  "Ver obras y frentes de trabajo": "Ehecha tembiapo guasu ha mba'apo rendakuéra",
  "Maquinaria municipal": "Tavao mba'yrumýi",
  "¿Dónde están las maquinarias?": "Moõpa oĩ mba'yrumýikuéra?",
  "Emitir obligación municipal": "Ejapo tavao jehepyme'ẽrã",
  "Registrar pago de caja": "Ehai viru ñehepyme'ẽ",
  "Ejercicio fiscal o periodo": "Ary virupurukue térã pa'ũ",
  "Dependencia responsable": "Tavao vore oñangarekóva",
  "Información clara, servicios accesibles y una Municipalidad presente en cada barrio y compañía. Un portal hecho para acercar Piribebuy a su gente.":
    "Marandu hesakãva, tembiaporã ojeikeporãva ha Tavao oĩva barrio ha compañía-kuérape. Peteĩ rokẽ omboja hag̃ua Piribebuy itavayguáre.",
  "La Municipalidad, trabajando a la vista": "Tavao, omba'apóva opavave resa renondépe",
  "Ver seguimiento municipal": "Ehecha tavao rembiapo rape",
  "¿Dónde están las maquinarias municipales?": "Moõpa oĩ tavao mba'yrumýikuéra?",
  "Ubicación y actividad publicada de las unidades con GPS habilitado.":
    "GPS oguerekóva mba'yrumýi renda ha hembiapo oñemyasãiva.",
  "Solo se muestran posiciones reales de unidades municipales con telemetría habilitada.":
    "Ojehechauka tavao mba'yrumýi renda tee telemetría oñembohapéva añoite.",
  "Tu voz también construye Piribebuy": "Ne ñe'ẽ avei omopu'ã Piribebuy",
  "Contanos qué necesita tu comunidad. Cada solicitud queda registrada para que puedas acompañar su recorrido de manera clara.":
    "Eremi oréve mba'épa oikotevẽ nde tekoha. Jerure peteĩteĩ oñeñongatu ikatu hag̃ua rehecha hape hesakã porã.",
  "Etapas de participación": "Ñepytyvõ rembiaporã",
  Presentá: "Emoinge",
  Seguí: "Ehapykueho",
  "Recibí respuesta": "Ehupyty ñembohovái",
  "Canal ciudadano": "Tavaygua rape",
  "Estamos para escucharte": "Roime rohendu hag̃ua",
  "Elegí el canal que mejor se adapte a tu consulta.":
    "Eiporavo tape iporãvéva ne porandúpe g̃uarã.",
  "Acceso a información pública": "Marandu opavavépe g̃uarã jeike",
  "Gobierno ejecutivo": "Tavao ñesãmbyhy",
  "Conocé a la autoridad ejecutiva y las funciones de la Intendencia de Piribebuy.":
    "Eikuaa Piribebuy intendencia mburuvicha ha hembiapokuéra.",
  "Autoridad ejecutiva, trayectoria institucional y funciones de la Intendencia de Piribebuy.":
    "Mburuvicha tembiapo, tembiasakue institucional ha Piribebuy Tavao Mburuvichaha rembiapokuéra.",
  "Gobierno Municipal": "Tavao Rekuái",
  "Nacido y criado en Piribebuy, el abogado Rodolfo Enmanuel Gini Orué desarrolló su formación y gran parte de su trayectoria pública en la ciudad. Es egresado de la Facultad de Derecho de la Universidad Nacional de Asunción y fue concejal municipal entre 2010 y 2015.":
    "Piribebuy-pe heñói ha okakuaa, abogado Rodolfo Enmanuel Gini Orué oñemoarandu ha omba'apo hetave ko táva rehe. Oñemoarandu Derecho-pe Universidad Nacional de Asunción-pe ha oiko concejal municipal ramo 2010 guive 2015 peve.",
  "Nacido y criado en Piribebuy, el abogado Rodolfo Enmanuel Gini Orué es hijo de Carlos Darío Gini, mecánico, y de la profesora Adaluz Orué, fundadora del Instituto de Formación Docente de Piribebuy. Cursó sus estudios en instituciones de la ciudad, culminó la educación media en el Colegio Nacional Piribebuy y se graduó en la Facultad de Derecho de la Universidad Nacional de Asunción. Fue concejal municipal entre 2010 y 2015. Su trayectoria comunitaria incluye una destacada labor como dirigente del Club 12 de Agosto, donde ejerció tres veces la vicepresidencia y tres veces la presidencia; durante su gestión dirigencial, la institución obtuvo el campeonato del fútbol de Piribebuy en 2019.":
    "Piribebuy-pe heñói ha okakuaa abogado Rodolfo Enmanuel Gini Orué. Carlos Darío Gini, mecánico, ha mbo'ehára Adaluz Orué, Instituto de Formación Docente de Piribebuy omoñepyrũva'ekue, ra'y. Oñemoarandu táva mbo'ehaokuérape, omohu'ã iñemoarandu Colegio Nacional Piribebuy-pe ha oiko abogado ramo Universidad Nacional de Asunción, Facultad de Derecho-pe. Oiko concejal municipal ramo 2010 guive 2015 peve. Hembiapo tekohápe oike avei Club 12 de Agosto ñesãmbyhy: mbohapy jey oiko vicepresidente ramo ha mbohapy jey presidente ramo; iñesãmbyhy aja, pe institución ohupyty Piribebuy fútbol campeonato 2019-pe.",
  "Nacido y criado en Piribebuy, es hijo de Carlos Darío Gini, mecánico, y de la profesora Adaluz Orué, fundadora del Instituto de Formación Docente de Piribebuy.":
    "Piribebuy-pe heñói ha okakuaa. Carlos Darío Gini, mecánico, ha mbo'ehára Adaluz Orué, Instituto de Formación Docente de Piribebuy omoñepyrũva'ekue, ra'y.",
  "Cursó sus estudios en instituciones de la ciudad, culminó la educación media en el Colegio Nacional Piribebuy y se graduó en la Facultad de Derecho de la Universidad Nacional de Asunción.":
    "Oñemoarandu táva mbo'ehaokuérape, omohu'ã iñemoarandu Colegio Nacional Piribebuy-pe ha oiko abogado ramo Universidad Nacional de Asunción, Facultad de Derecho-pe.",
  "En el Club 12 de Agosto ejerció tres veces la vicepresidencia y tres veces la presidencia. Durante su gestión dirigencial, la institución obtuvo el campeonato del fútbol de Piribebuy en 2019.":
    "Club 12 de Agosto-pe mbohapy jey oiko vicepresidente ramo ha mbohapy jey presidente ramo. Iñesãmbyhy aja, pe institución ohupyty Piribebuy fútbol campeonato 2019-pe.",
  "Nacido y criado en Piribebuy, el abogado Rodolfo Enmanuel Gini Orué desarrolló su formación y gran parte de su trayectoria pública en la ciudad.":
    "Piribebuy-pe heñói ha okakuaa, abogado Rodolfo Enmanuel Gini Orué oñemoarandu ha omba'apo hetave ko táva rehe.",
  "Resumen de trayectoria": "Tembiasakue mbykymi",
  Formación: "Ñemoarandu",
  "Abogado por la UNA": "Abogado UNA-gui",
  "Experiencia municipal": "Tavao rembiapo rembiasakue",
  "Concejal entre 2010 y 2015": "Tavao Atygua 2010 guive 2015 peve",
  Trayectoria: "Tembiasakue",
  "Comunitaria y deportiva": "Tekoha ha deporte rehegua",
  "Una trayectoria vinculada a Piribebuy": "Peteĩ tembiasakue joajúva Piribebuy rehe",
  "Raíces en la ciudad": "Táva rapóre",
  "Nacido y criado en Piribebuy, cursó sus estudios escolares en instituciones de la comunidad y completó la secundaria en el Colegio Nacional Piribebuy.":
    "Piribebuy-pe heñói ha okakuaa, oñemoarandu tekoha mbo'ehaokuérape ha omohu'ã secundaria Colegio Nacional Piribebuy-pe.",
  "Formación profesional": "Ñemoarandu profesional",
  "Obtuvo el título de abogado en la Facultad de Derecho de la Universidad Nacional de Asunción.":
    "Ohupyty abogado título Facultad de Derecho, Universidad Nacional de Asunción-pe.",
  "Integró el Concejo Municipal de Piribebuy entre 2010 y 2015, con experiencia directa en la gestión y el trabajo institucional del gobierno local.":
    "Oĩ Piribebuy Concejo Municipal-pe 2010 guive 2015 peve, ha upépe ohupyty tembiasakue tavao ñesãmbyhy ha tembiapo institucional-pe.",
  "Participación comunitaria": "Tekoha ndive ñepytyvõ",
  "Su trayectoria incluye participación en espacios sociales y conducción deportiva, manteniendo una vinculación constante con las instituciones locales.":
    "Hembiasakuépe oĩ tekoha rembiapo ha deporte ñesãmbyhy, ha akóinte ojoaju ko táva institución-kuéra ndive.",
  "Funciones de la Intendencia": "Tavao Mburuvichaha rembiapokuéra",
  "Administración pública": "Opavave mba'e ñesãmbyhy",
  "Gestiona los recursos municipales dentro de las competencias y normas vigentes.":
    "Oñangareko tavao mba'erepy rehe hembiapo ha léi oĩva ryepýpe.",
  "Coordina las dependencias, los servicios locales y la atención de trámites.":
    "Omohenda tavao vorekuéra, tembiaporã ha kuatia ñangareko.",
  "Vínculo con la comunidad": "Joaju tekoha ndive",
  "Articula acciones con los barrios, las compañías y las organizaciones de Piribebuy.":
    "Ombojoaju tembiapo barrio, compañía ha Piribebuy atykuéra ndive.",
  "La información publicada en este portal complementa la atención presencial. La documentación municipal oficial constituye la fuente administrativa y normativa.":
    "Marandu ko portal-pe oñemyasãiva ombojoapy ñangareko presencial. Tavao kuatia tee ha'e marandu ñesãmbyhy ha léi ypykue.",
  "Conocé a los integrantes de la Junta Municipal y su representación política.":
    "Eikuaa Junta Municipal peguakuéra ha mba'éichapa ohechauka aty polítiko-kuérape.",
  "Organización municipal": "Tavao ñemboheko",
  "Consultá las áreas municipales, sus funciones y canales de atención publicados.":
    "Ehecha tavao vorekuéra, hembiapokuéra ha oñemyasãiva ñangareko rape.",
  "Contenido de esta página": "Ko kuatiápe oĩva",
  "Documento institucional": "Kuatia institucional",
  Ámbito: "Moõ pevépa ohupyty",
  "Portal web y servicios digitales": "Portal web ha tembiaporã digital",
  "Índice del documento": "Kuatia vore rysýi",
  "En esta página": "Ko kuatiápe",
  "Este documento debe interpretarse junto con la Constitución Nacional, las leyes, ordenanzas y reglamentos vigentes. Ninguna disposición del portal limita derechos reconocidos por normas de mayor jerarquía. Ante una diferencia de traducción, prevalecen el texto oficial en español y la fuente normativa correspondiente.":
    "Ko kuatia oñemoñe'ẽva'erã Constitución Nacional, léi, ordenanza ha reglamento oikovéva ndive. Portal mba'eve ndaikatúi omomichĩ derecho kuéra léi yvatevéva ome'ẽva. Ñe'ẽasa ojoavy jave, oñemotenonde español-pe kuatia tee ha léi ypykue.",
  "Compromiso de accesibilidad": "Jeikeporã compromiso",
  "El Gobierno Municipal de Piribebuy procura que este portal pueda ser comprendido y utilizado por la mayor cantidad posible de personas, independientemente de sus capacidades, tecnología, idioma o dispositivo.":
    "Piribebuy Tavao Rekuái oñeha'ã ko portal oikũmby ha oiporu hag̃ua opavave ikatúva, taha'e ha'éva ikatupyry, tecnología, ñe'ẽ térã tembiporu oipurúva.",
  "El diseño se orienta a las Pautas de Accesibilidad para el Contenido Web WCAG 2.2, nivel AA. Esta declaración expresa un objetivo de mejora continua y no constituye una certificación externa de conformidad total.":
    "Diseño oñembohape WCAG 2.2 nivel AA jeikeporã rehe. Ko declaración he'ise ñemyatyrõ tapia, ndaha'éi certificación externa cumplimiento completo rehegua.",
  "Medidas implementadas": "Medida oñemoĩmava",
  "Estructura semántica, jerarquía de encabezados y enlace para saltar al contenido principal.":
    "Estructura semántica, título ñemohenda ha enlace ojehasa hag̃ua contenido principal-pe.",
  "Navegación mediante teclado, foco visible y controles con nombres accesibles.":
    "Teclado rupive jeike, foco ojehecháva ha control réra oikũmbykuaáva.",
  "Contraste reforzado, aumento de texto, escala de grises, subrayado de enlaces y modo oscuro.":
    "Contraste mbarete, jehaipyre ñembotuicha, gris escala, enlace guyhai ha modo pytũ.",
  "Contenido adaptable a teléfonos, tabletas, computadoras y ampliación del navegador.":
    "Contenido oñemohenda teléfono, tableta, computadora ha navegador ñembotuichápe.",
  "Estados y mensajes comunicados con texto, iconos y anuncios para tecnologías de asistencia.":
    "Estado ha marandu oñembohasa jehaipyre, ta'ãnga'i ha tecnología pytyvõrã rupive.",
  "Reducción de movimiento cuando el dispositivo o la persona así lo solicita.":
    "Movimiento oñemomichĩ tembiporu térã tapicha ojerure jave.",
  "Contenido principal disponible en español y avañe’ẽ.":
    "Contenido principal oĩ español ha avañe'ẽme.",
  "Compatibilidad y tecnologías de asistencia": "Compatibilidad ha tecnología pytyvõrã",
  "El portal está diseñado para navegadores modernos y para su uso con lectores de pantalla, ampliadores, navegación por voz y teclado. Para obtener mejores resultados, se recomienda mantener actualizado el navegador y el sistema operativo.":
    "Portal ojejapo navegador ipyahúva, pantalla moñe'ẽha, ñembotuichaha, ñe'ẽ ha teclado rupive ojeiporu hag̃ua. Iporãve navegador ha sistema operativo oñembopyahu tapia.",
  "Las preferencias de accesibilidad se guardan únicamente en el dispositivo utilizado y pueden restablecerse desde la barra de accesibilidad.":
    "Jeikeporã preferencia oñeñongatu tembiporu ojeporúvape añoite ha ikatu oñemoñepyrũjey jeikeporã barra guive.",
  "Limitaciones conocidas": "Apañuãi ojekuaáva",
  "Algunos documentos históricos digitalizados, archivos PDF heredados, mapas, contenidos incorporados desde terceros o publicaciones antiguas pueden no alcanzar todavía el mismo nivel de accesibilidad que las páginas nuevas.":
    "Kuatia ymaguare oñedigitalisáva, PDF heredado, mapa, tercero contenido térã publicación ymaguare ikatu ne'ĩra ohupyty página pyahu jeikeporã nivel.",
  "Cuando un contenido no sea accesible, la Municipalidad procurará entregar una alternativa razonable en formato comprensible, siempre que la naturaleza del documento y la normativa aplicable lo permitan.":
    "Contenido ndaikatúi ojeiporu porã jave, Tavao ome'ẽta ambue tape ikatúva ha formato oikũmbykuaáva, kuatia reko ha léi ohejáramo.",
  "Cómo reportar una barrera": "Mba'éichapa emomarandúta peteĩ jokoha",
  "Indicá la dirección de la página, el problema encontrado, el dispositivo, el navegador y, si corresponde, la tecnología de asistencia utilizada. No incluyas contraseñas, códigos de recuperación ni datos sensibles innecesarios.":
    "Emombe'u página dirección, apañuãi, tembiporu, navegador ha, tekotevẽramo, tecnología pytyvõrã reipurúva. Ani emoĩ contraseña, código jeguerujey térã dato sensible oñeikotevẽ'ỹva.",
  "El reporte será registrado, derivado al área responsable y priorizado según su impacto. Para trámites urgentes o con plazo legal, utilizá también el canal presencial o la Mesa de Entrada Digital.":
    "Marandu oñeñongatu, oñemondo vore omba'apóvape ha oñemotenonde imba'eguasu rehe. Kuatia pya'e térã plazo legal orekóvape, eiporu avei canal presencial térã Mesa de Entrada Digital.",
  "Reportar una barrera de accesibilidad": "Emomarandu jeikeporã jokoha",
  "Marco de referencia": "Mbojojaha ypykue",
  "Ley N.º 4934/2013 de accesibilidad al medio físico":
    "Léi N.º 4934/2013 jeikeporã tekoha físico-pe",
  "Ley N.º 3540/2008 y Convención sobre los Derechos de las Personas con Discapacidad":
    "Léi N.º 3540/2008 ha Convención tapicha discapacidad orekóva derecho rehegua",
  "WCAG 2.2 — Recomendación del W3C": "WCAG 2.2 — W3C rekomendación",
  "Declaración de accesibilidad": "Jeikeporã declaración",
  "Compromisos, medidas y canales para que los servicios digitales municipales puedan ser utilizados por todas las personas.":
    "Compromiso, medida ha tape opavave oiporu hag̃ua tavao tembiaporã digital.",
  "Mejora continua": "Ñemyatyrõ tapia",
  "Responsable y alcance": "Responsable ha ohupytyha",
  "El Gobierno Municipal de Piribebuy es responsable de determinar las finalidades y medios del tratamiento de datos personales realizado mediante este portal. Arandu Dev actúa como proveedor tecnológico y encargado cuando trata datos exclusivamente bajo instrucciones municipales y conforme al contrato aplicable.":
    "Piribebuy Tavao Rekuái ha'e responsable ombohéra hag̃ua mba'erã ha mba'éichapa oñemba'apo dato personal rehe ko portal rupive. Arandu Dev ha'e proveedor tecnológico ha encargado omba'apo jave dato rehe tavao instrucción ha contrato poguýpe añoite.",
  "Esta política se aplica al portal público, las cuentas ciudadanas, la Mesa de Entrada Digital, los reclamos, los servicios internos, la Academia Municipal y los demás módulos identificados como parte de Piribebuy Digital.":
    "Ko política ojeiporu portal público, tavaygua cuenta, Mesa de Entrada Digital, reclamo, tembiaporã interno, Academia Municipal ha ambue módulo Piribebuy Digital reheguápe.",
  "Datos que pueden tratarse": "Dato ikatúva oñemba'apo",
  "Datos de identificación y contacto necesarios para crear una cuenta o verificar identidad.":
    "Identificación ha contacto dato oñeikotevẽva cuenta jejapo térã identidad jehechajeyrã.",
  "Información, documentos y fotografías incorporados a trámites, reclamos o expedientes.":
    "Marandu, kuatia ha ta'ãnga oñemoĩva trámite, reclamo térã expediente-pe.",
  "Ubicación geográfica únicamente cuando la persona la autoriza para señalar una incidencia o prestar un servicio.":
    "Tenda geográfica tapicha omoneĩ jave añoite, peteĩ apañuãi ohechauka térã tembiaporã oñeme'ẽ hag̃ua.",
  "Datos académicos y de participación cuando se utilizan servicios de formación municipal.":
    "Ñemoarandu ha participación dato ojeporu jave tavao formación tembiaporã.",
  "Metadatos de seguridad, accesos, cambios, auditoría y actividad necesaria para prevenir abusos.":
    "Seguridad, jeike, ñemoambue, auditoría ha tembiapo metadato oñeikotevẽva jeporu vai jejokorã.",
  "Ruta pública visitada, fecha e identificador aleatorio de sesión para estadísticas agregadas del portal.":
    "Ruta pública ojehecháva, arange ha sesión identificador aleatorio portal estadística atyguápe g̃uarã.",
  "Datos de una operación de pago cuando el servicio se habilite; el portal municipal no debe almacenar el número completo de tarjeta ni su código de seguridad.":
    "Pago operación dato tembiaporã oñemoneĩ jave; portal municipal noñongatúi va'erã tarjeta número completo térã seguridad código.",
  "Finalidades y bases del tratamiento": "Dato jeporu rembipota ha pyenda",
  "Los datos se utilizan para identificar a la persona, prestar servicios municipales, tramitar solicitudes, emitir constancias, comunicar novedades, proteger la plataforma, auditar actuaciones y cumplir obligaciones legales.":
    "Dato ojeporu tapicha jeikuaa, tavao tembiaporã ñeme'ẽ, jerure ñemohenda, constancia ñeguenohẽ, marandu pyahu ñemondo, plataforma ñangareko, tembiapo auditoría ha obligación legal ñekumplirã.",
  "El tratamiento se fundamenta, según el caso, en el cumplimiento de funciones públicas y obligaciones legales, la gestión de una solicitud de la persona, la ejecución de una relación de servicio, la protección de sistemas y el consentimiento cuando la ley lo exige. No se venden datos personales ni se utilizan para publicidad comercial basada en perfiles.":
    "Dato jeporu oñemopyenda, káso rehe, función pública ha obligación legal ñekumpli, tapicha jerure ñemohenda, tembiaporã relación, sistema ñangareko ha consentimiento léi ojerure jave. Dato personal noñevendéi ha ndojeporúi publicidad comercial perfil reheguápe.",
  "Analítica, almacenamiento local y cookies": "Analítica, ñongatu local ha cookies",
  "La analítica municipal registra la ruta pública consultada, la fecha y un identificador aleatorio de la sesión. No incorpora los parámetros de búsqueda ni la identidad de la persona en ese registro estadístico.":
    "Tavao analítica oñongatu ruta pública ojehecháva, arange ha sesión identificador aleatorio. Nomoĩri jeheka parámetro térã tapicha identidad upe registro estadístico-pe.",
  "El navegador conserva preferencias indispensables, como idioma, tema, accesibilidad, actividad de sesión y borradores habilitados. No se utilizan cookies publicitarias. Los proveedores de infraestructura pueden procesar temporalmente datos técnicos de red para entregar el servicio, detectar ataques y mantener registros de seguridad.":
    "Navegador oñongatu preferencia oñeikotevẽva: ñe'ẽ, tema, jeikeporã, sesión actividad ha borrador oñemoneĩva. Ndojeporúi cookie publicitaria. Infraestructura proveedor ikatu sapy'ami omba'apo red dato técnico rehe tembiaporã ñeme'ẽ, ataque jehechakuaa ha seguridad registro ñongaturã.",
  "Proveedores, destinatarios y transferencias": "Proveedor, ohupytýva ha transferencia",
  "El acceso se limita al personal municipal autorizado, proveedores que prestan servicios de alojamiento, autenticación, base de datos, almacenamiento, comunicaciones o pagos, y autoridades competentes cuando exista una obligación legal o requerimiento válido.":
    "Jeike oñeme'ẽ tavao personal oñemoneĩvape, alojamiento, autenticación, base de datos, ñongatu, comunicación térã pago proveedor-kuérape, ha mburuvicha ikatupyrývape obligación legal térã jerure válido oĩ jave.",
  "Algunos proveedores pueden operar infraestructura fuera del Paraguay. En esos casos se aplican medidas contractuales, técnicas y organizativas razonables, minimización de datos y controles de acceso acordes con el riesgo y la legislación aplicable.":
    "Oĩ proveedor ikatúva omba'apo Paraguay okápe. Upéicha jave oñemoĩ medida contractual, técnica ha organizativa hekopete, dato ñemomichĩ ha jeike control riesgo ha léi oikovéva rehe.",
  "Conservación y archivo": "Ñongatu ha archivo",
  "Los datos se conservan durante el tiempo necesario para la finalidad informada y posteriormente durante los plazos exigidos por normas administrativas, fiscales, archivísticas, de transparencia, control y responsabilidad pública.":
    "Dato oñeñongatu aravo oñeikotevẽva rembipota oñemombe'úvape g̃uarã ha upéi norma administrativa, fiscal, archivo, transparencia, control ha responsabilidad pública plazo pukukue.",
  "La eliminación no procede cuando exista deber legal de conservación, interés público documentado, necesidad probatoria o afectación de derechos de terceros. Cumplido el plazo aplicable, los datos se eliminan, anonimizan o quedan sujetos al régimen de archivo público correspondiente.":
    "Ndojepe'ái dato oĩramo deber legal oñeñongatu hag̃ua, interés público ojehaíva, prueba oñeikotevẽva térã tercero derecho rehegua. Plazo opa rire, dato ojepe'a, oñemokañy identidad térã opyta archivo público régimen poguýpe.",
  "Seguridad y respuesta ante incidentes": "Seguridad ha apañuãi ñembohovái",
  "Se aplican controles de autenticación, permisos por función, registro de acciones, cifrado en tránsito, separación entre contenido público e interno, copias de respaldo y revisión de accesos. Ningún sistema es infalible y los controles se revisan conforme evolucionan los riesgos.":
    "Oñemoĩ autenticación control, permiso función rehe, tembiapo registro, cifrado ñemondópe, contenido público ha interno ñemboja'o, copia respaldo ha jeike jehechajey. Ndaipóri sistema ndojavýiva ha control ojehechajey riesgo iñambuévo.",
  "Los incidentes se documentan, contienen e investigan. Cuando corresponda, se notifica a las autoridades y a las personas afectadas de acuerdo con la ley y con información que permita reducir posibles daños.":
    "Apañuãi ojehai, ojejoko ha oñehesa'ỹijo. Tekotevẽ jave oñemomarandu mburuvicha ha tapicha ojehupytývape léi he'iháicha, marandu omomichĩ hag̃ua perjuicio ikatúva.",
  "Derechos de las personas": "Tapichakuéra derecho",
  "Podés solicitar información, acceso, actualización, rectificación, supresión, oposición, portabilidad o revisión de decisiones automatizadas cuando resulte aplicable. La identidad deberá verificarse antes de entregar o modificar datos.":
    "Ikatu rejerure marandu, jeike, ñembopyahu, ñemyatyrõ, ñembogue, oposición, portabilidad térã decisión automatizada jehechajey oikóramo. Identidad ojehechajey va'erã dato ñeme'ẽ térã ñemoambue mboyve.",
  "La solicitud es gratuita y puede presentarse por el canal de contacto o Mesa de Entrada. Se responderá en un plazo máximo de treinta días corridos, salvo un plazo legal diferente. También permanece disponible la garantía constitucional de hábeas data y, desde su habilitación legal, el reclamo ante la autoridad de control competente.":
    "Jerure reiete ha ikatu oñemoguahẽ contacto rape térã Mesa de Entrada-pe. Oñembohováita 30 ára pukukue ryepýpe, léi ambue plazo nome'ẽiramo. Oĩ avei hábeas data garantía constitucional ha, léi omoneĩ rire, reclamo autoridad de control-pe.",
  "Ejercer un derecho sobre mis datos": "Aiporu che dato rehegua derecho",
  "Niños, adolescentes y datos sensibles": "Mitã, mitãrusu ha dato sensible",
  "Los datos de niños, niñas y adolescentes y las categorías sensibles reciben protección reforzada. Solo deben solicitarse cuando sean estrictamente necesarios, con lenguaje claro, acceso restringido y la autorización o base legal que corresponda. Nunca publiques datos sensibles en campos abiertos o comentarios.":
    "Mitã ha mitãrusu dato, ha dato sensible, oñeñangareko mbareteve. Ojejerure va'erã oñeikotevẽ añetéramo añoite, ñe'ẽ hesakãva, jeike oñemomichĩva ha autorización térã pyenda legal reheve. Ani araka'eve emoherakuã dato sensible campo abierto térã comentario-pe.",
  "Normativa y transición": "Mbojojaha ha jehasa",
  "Esta política se apoya en los artículos 28, 33, 36 y 135 de la Constitución Nacional y adopta anticipadamente los principios de la Ley N.º 7593/2025. Esa ley fue publicada el 27 de noviembre de 2025 y entrará en vigor el 27 de noviembre de 2027, sin perjuicio de las normas actualmente aplicables.":
    "Ko política oñemopyenda Constitución Nacional artículo 28, 33, 36 ha 135 rehe ha oguereko mboyve guive Léi N.º 7593/2025 principio. Upe léi oñemyasãi 27 jasypateĩ 2025-pe ha oñepyrũta 27 jasypateĩ 2027-pe, ko'ág̃a norma oikovéva omboje'o'ỹre.",
  "Constitución de la República del Paraguay": "Paraguái Retã Constitución",
  "Ley N.º 7593/2025 de Protección de Datos Personales":
    "Léi N.º 7593/2025 Dato Personal Ñangareko rehegua",
  "Ley N.º 5282/2014 de acceso a la información pública":
    "Léi N.º 5282/2014 marandu opavavépe g̃uarã jeike rehegua",
  "Política de privacidad": "Ñemigua ñangareko política",
  "Qué datos utiliza Piribebuy Digital, para qué se emplean, cómo se protegen y qué derechos conserva cada persona.":
    "Mba'e dato oiporu Piribebuy Digital, mba'erã, mba'éichapa oñeñangareko ha mba'e derecho oguereko tapicha.",
  "Aplicación institucional": "Jeporu institucional",
  "Objeto y aceptación": "Rembipota ha ñemoneĩ",
  "Estos términos regulan el acceso y uso de Piribebuy Digital y de los servicios digitales ofrecidos por el Gobierno Municipal de Piribebuy. Al utilizar el portal, la persona se compromete a actuar de buena fe y conforme a la normativa vigente.":
    "Ko condición omohenda Piribebuy Digital ha Piribebuy Tavao Rekuái tembiaporã digital jeike ha jeporu. Portal oipurúvo, tapicha oñeme'ẽ iñe'ẽ omba'apo hag̃ua jerovia porã ha norma oikovéva he'iháicha.",
  "La consulta de información pública no requiere aceptar obligaciones distintas de las previstas por ley. Para crear una cuenta, presentar solicitudes o usar funciones autenticadas deben aceptarse las condiciones aplicables al servicio.":
    "Marandu opavavépe g̃uarã jehecha noikotevẽi obligación ambue léi he'íva gui. Cuenta jejapo, jerure ñemoguahẽ térã función autenticada jeporurã oñemoneĩ va'erã tembiaporã condición.",
  "Cuentas, identidad y credenciales": "Cuenta, identidad ha credencial",
  "La información de registro debe ser veraz, actualizada y perteneciente a la persona o representación declarada. Cada usuario es responsable de proteger su contraseña, cerrar la sesión en dispositivos compartidos y reportar accesos no reconocidos.":
    "Registro marandu añetegua, ipyahúva ha tapicha térã representante oje'éva mba'e va'erã. Usuario peteĩteĩ oñangareko va'erã contraseña rehe, omboty sesión tembiporu oñemboja'óvape ha omomarandu jeike ndoikuaáiva.",
  "Está prohibido suplantar identidades, compartir credenciales institucionales, eludir controles de acceso o utilizar una cuenta para actuar sin autorización. La Municipalidad podrá requerir verificación adicional antes de ejecutar actos con efectos jurídicos o económicos.":
    "Oñembotove identidad japu jeporu, credencial institucional ñemboja'o, jeike control jehasa vai térã cuenta jeporu autorización'ỹre. Tavao ikatu ojerure jehechajey ambue ojapo mboyve acto efecto jurídico térã económico orekóva.",
  "Presentaciones y constancias electrónicas": "Ñemoguahẽ ha constancia electrónica",
  "Un borrador, formulario incompleto, mensaje de orientación o archivo cargado no constituye por sí solo una presentación formal. La solicitud se considera recibida cuando el sistema emite una constancia o número de expediente, salvo que la normativa específica disponga otra formalidad.":
    "Borrador, formulario incomplete, ñe'ẽmondo orientación térã archivo oñehupíva ndaha'éi ijehegui presentación formal. Jerure ojehecha oñeguahẽramo sistema ome'ẽ jave constancia térã expediente número, norma específica ambue mba'e nde'íriramo.",
  "La persona debe conservar la constancia y verificar los datos enviados. Los plazos administrativos, requisitos, subsanaciones, notificaciones y recursos se rigen por la normativa aplicable a cada trámite, incluida la Ley N.º 6715/2021.":
    "Tapicha oñongatu va'erã constancia ha ohechajey dato omondóva. Plazo administrativo, requisito, subsanación, notificación ha recurso oñemohenda trámite peteĩteĩ norma rehe, Léi N.º 6715/2021 avei.",
  "Uso permitido y conductas prohibidas": "Jeporu oñemoneĩva ha conducta oñembotovéva",
  "Utilizar el portal únicamente para fines lícitos y relacionados con servicios municipales.":
    "Eiporu portal mba'e lícito ha tavao tembiaporã rehegua añoite.",
  "No introducir código malicioso, automatizar consultas abusivas ni intentar degradar el servicio.":
    "Ani emoinge código vai, ani eautomatisa consulta abusiva térã eñeha'ã embyaívo tembiaporã.",
  "No acceder, copiar, modificar o divulgar información sin autorización.":
    "Ani eike, ekopia, emoambue térã emoherakuã marandu autorización'ỹre.",
  "No presentar documentación falsa, contenido ilícito o material que vulnere derechos de terceros.":
    "Ani emoguahẽ kuatia japu, contenido ilícito térã material omomarãva tercero derecho.",
  "No acosar al personal, saturar canales ni utilizar el sistema para campañas comerciales o partidarias no autorizadas.":
    "Ani emoapañuãi personal-pe, ani emyenyhẽ rei canal térã eiporu sistema campaña comercial térã partidaria oñemoneĩ'ỹvape.",
  "No explotar errores de seguridad; deben reportarse de forma responsable y sin ampliar el daño.":
    "Ani eiporu vai seguridad jejavy; emomarandu responsabilidad reheve ha ani embotuicha perjuicio.",
  "Documentos y contenido aportado": "Kuatia ha contenido oñeme'ẽva",
  "La persona conserva los derechos que correspondan sobre el contenido aportado y declara contar con autorización para presentarlo. Al enviarlo, autoriza su tratamiento, archivo, reproducción interna y comunicación a las dependencias o autoridades necesarias para resolver la gestión.":
    "Tapicha oguereko gueteri derecho oĩva contenido ome'ẽva rehe ha he'i orekoha autorización omoguahẽ hag̃ua. Omondóvo, omoneĩ dato jeporu, archivo, reproducción interna ha ñemomarandu vore térã mburuvicha oñeikotevẽvape gestión ñemyatyrõrã.",
  "No deben incluirse datos de terceros o información sensible que no resulte necesaria. La Municipalidad puede rechazar, aislar o retirar archivos que comprometan la seguridad, sean manifiestamente ilícitos o no guarden relación con la solicitud, dejando constancia cuando corresponda.":
    "Ani emoĩ tercero dato térã marandu sensible oñeikotevẽ'ỹva. Tavao ikatu ombotove, omboja'o térã oipe'a archivo ombyaiha seguridad, ilícito hesakãva térã ndojoajúiva jerure rehe, ha oheja constancia tekotevẽ jave.",
  "Disponibilidad, exactitud y canales alternativos": "Disponibilidad, exactitud ha ambue canal",
  "Se procura mantener información actualizada y servicios disponibles, pero pueden existir mantenimientos, fallas de conectividad, incidentes o contenidos en proceso de actualización. La sección Estado de servicios informa incidencias conocidas cuando sea posible.":
    "Oñeñeha'ã marandu ipyahúva ha tembiaporã ojeporukuaáva, jepémo ikatu oĩ mantenimiento, conexión jejavy, apañuãi térã contenido oñembopyahúva. Estado de servicios vore omomarandu apañuãi ojekuaáva ikatu jave.",
  "Si una interrupción impide cumplir un plazo, la persona debe utilizar los canales alternativos habilitados y conservar evidencia. Ante diferencias entre el portal y una norma, ordenanza, resolución o acto administrativo válido, prevalece el texto oficial vigente.":
    "Ñembogue ojoko jave plazo ñekumpli, tapicha oiporu va'erã ambue canal oñemoneĩva ha oñongatu prueba. Portal ha norma, ordenanza, resolución térã acto administrativo válido ojoavy jave, oñemotenonde kuatia tee oikovéva.",
  "Consultar estado de servicios": "Ehecha tembiaporã reko",
  "Información pública y propiedad intelectual": "Marandu opavavépe g̃uarã ha propiedad intelectual",
  "La información pública se rige por la Constitución y la Ley N.º 5282/2014. Su consulta es gratuita y no exige explicar el motivo. Las excepciones de reserva deben estar previstas por ley.":
    "Marandu opavavépe g̃uarã oñemohenda Constitución ha Léi N.º 5282/2014 rehe. Jehecha reiete ha nojeruréi mba'érepa. Reserva excepción léipe oĩ va'erã.",
  "Las marcas, elementos gráficos, software y contenidos protegidos no se ceden por el acceso al portal. La reutilización de datos públicos debe respetar integridad, fuente, fecha de actualización, derechos de terceros y las condiciones o licencias indicadas en cada conjunto de datos.":
    "Marca, ta'ãnga, software ha contenido oñeñangarekóva noñeme'ẽi portal jeike rehe. Dato público jeporujey omomba'e va'erã integridad, ypykue, arange ñembopyahu, tercero derecho ha condición térã licencia dato atýpe oje'éva.",
  "Protección del servicio y suspensión": "Tembiaporã ñangareko ha suspensión",
  "El acceso puede limitarse temporalmente cuando existan indicios razonables de fraude, ataque, uso abusivo, credenciales comprometidas o incumplimiento grave. Las medidas serán proporcionales, registradas y revisables, sin impedir el uso de canales alternativos ni el ejercicio de derechos administrativos.":
    "Jeike ikatu oñemomichĩ sapy'ami oĩramo fraude, ataque, jeporu abusivo, credencial oĩva peligro-pe térã incumplimiento grave rechaukaha. Medida hekopete, oñeregistra ha ojehechajeykuaa va'erã, ambue canal jeporu ha derecho administrativo ojoko'ỹre.",
  Responsabilidad: "Responsabilidad",
  "Cada parte responde por sus actos conforme a la ley. Ninguna cláusula excluye la responsabilidad que legalmente corresponda a la Municipalidad, sus agentes, los proveedores o las personas usuarias, ni limita derechos constitucionales, administrativos, de consumo o de protección de datos.":
    "Parte peteĩteĩ ombohovái hembiapo rehe léi he'iháicha. Cláusula mba'eve ndoipe'ái responsabilidad legal Tavao, hembijokuái, proveedor térã usuario-gui, ha nomomichĩri derecho constitucional, administrativo, consumo térã dato ñangareko rehegua.",
  "Cambios, ley aplicable y consultas": "Ñemoambue, léi oikovéva ha consulta",
  "Los términos pueden actualizarse por cambios normativos, operativos o de seguridad. La versión vigente mostrará su fecha y los cambios sustanciales se comunicarán por medios razonables antes de aplicarse cuando sea necesario.":
    "Condición ikatu oñembopyahu norma, tembiapo térã seguridad iñambuévo. Versión oikovéva ohechaukáta hi'arange ha ñemoambue tuicháva oñemomarandúta tape hekopetéva rupive oñepyrũ mboyve tekotevẽ jave.",
  "Se aplica el ordenamiento jurídico de la República del Paraguay y la normativa municipal de Piribebuy. Las controversias seguirán primero los procedimientos y recursos administrativos disponibles, sin perjuicio del acceso a la autoridad o jurisdicción competente.":
    "Ojeiporu Paraguái Retã ordenamiento jurídico ha Piribebuy tavao norma. Joavy oñembohape raẽta procedimiento ha recurso administrativo oĩva rupive, autoridad térã jurisdicción ikatupyrývape jeike omboje'o'ỹre.",
  "Ley N.º 6715/2021 de Procedimientos Administrativos":
    "Léi N.º 6715/2021 Procedimiento Administrativo rehegua",
  "Ley N.º 6822/2021 sobre documentos y transacciones electrónicas":
    "Léi N.º 6822/2021 kuatia ha transacción electrónica rehegua",
  "Ley N.º 3966/2010 Orgánica Municipal": "Léi N.º 3966/2010 Orgánica Municipal",
  "Realizar una consulta": "Ajapo peteĩ consulta",
  "Condiciones institucionales": "Condición institucional",
  "Reglas claras para consultar información, utilizar una cuenta y presentar gestiones por medios digitales.":
    "Regla hesakãva marandu jehecha, cuenta jeporu ha gestión digital ñemoguahẽrã.",
  "Condiciones vigentes": "Condición oikovéva",
  "Qué es Piribebuy Digital": "Mba'épa Piribebuy Digital",
  "Piribebuy Digital es la plataforma de servicios digitales del Gobierno Municipal de Piribebuy. Reúne información institucional, transparencia, trámites, expedientes, reclamos, noticias, turismo, movilidad, formación y herramientas de gestión en un entorno común.":
    "Piribebuy Digital ha'e Piribebuy Tavao Rekuái tembiaporã digital plataforma. Ombyaty marandu institucional, transparencia, trámite, expediente, reclamo, noticia, turismo, movilidad, formación ha gestión tembiporu peteĩ tendápe.",
  "Su finalidad es facilitar la relación entre la ciudadanía y la Municipalidad, ordenar procesos, fortalecer la trazabilidad y ampliar el acceso a la información y a los servicios públicos.":
    "Hembipota ha'e ombohape tavaygua ha Tavao joaju, omohenda proceso, omombarete trazabilidad ha ombotuicha jeike marandu ha tembiaporã público-pe.",
  "Titularidad y gobernanza": "Járape ha ñesãmbyhy",
  "La Municipalidad define las políticas públicas, los procedimientos, los contenidos oficiales, los permisos y las finalidades del tratamiento de datos. Cada dependencia es responsable de validar y mantener actualizada la información correspondiente a su competencia.":
    "Tavao ombohéra política pública, procedimiento, contenido tee, permiso ha dato jeporu rembipota. Vore peteĩteĩ responsable ohechajey ha ombopyahu hag̃ua marandu hembiapo rehegua.",
  "Arandu Dev realiza el desarrollo tecnológico y presta servicios de soporte bajo las instrucciones, controles y contratos aplicables. La prestación tecnológica no transfiere la titularidad de los datos, expedientes ni documentos municipales.":
    "Arandu Dev ojapo desarrollo tecnológico ha soporte tavao instrucción, control ha contrato poguýpe. Tembiaporã tecnológico nome'ẽi dato, expediente térã kuatia municipal járape Arandu Dev-pe.",
  "Principios del proyecto": "Proyecto principio",
  "Servicio público centrado en las personas y disponible también por canales no digitales.":
    "Tembiaporã público tapicha rehe oñemopyendáva ha oĩva avei canal ndaha'éiva digital rupive.",
  "Transparencia por diseño, trazabilidad y responsabilidad de cada actuación.":
    "Transparencia diseño guive, trazabilidad ha responsabilidad tembiapo peteĩteĩre.",
  "Privacidad, minimización de datos y seguridad desde el diseño y por defecto.":
    "Ñemigua ñangareko, dato ñemomichĩ ha seguridad diseño guive ha por defecto.",
  "Accesibilidad, lenguaje claro y contenido principal en español y avañe’ẽ.":
    "Jeikeporã, ñe'ẽ hesakãva ha contenido principal español ha avañe'ẽme.",
  "Interoperabilidad, formatos reutilizables y reducción de dependencias tecnológicas innecesarias.":
    "Interoperabilidad, formato ojeporujeykuaáva ha dependencia tecnológica oñeikotevẽ'ỹva ñemomichĩ.",
  "Mejora continua basada en evidencia, auditoría y retroalimentación ciudadana.":
    "Ñemyatyrõ tapia oñemopyendáva prueba, auditoría ha tavaygua remiandu rehe.",
  "Alcance de los servicios": "Tembiaporã ohupytyha",
  "Las funciones se habilitan de manera progresiva. Cada ficha de trámite informa requisitos, dependencia responsable, costo, modalidad y canal disponible. La publicación de un módulo no implica que todas sus operaciones estén habilitadas para todas las personas o dependencias.":
    "Función oñemoneĩ mbeguekatúpe. Trámite ficha peteĩteĩ omombe'u requisito, vore responsable, repykue, modalidad ha canal oĩva. Módulo ñemyasãi nde'iséi opa operación oĩmaha opavave tapicha térã vore pe g̃uarã.",
  "Las funciones con efectos jurídicos, económicos o administrativos incorporan autenticación, permisos, constancias y registros de auditoría según el nivel de riesgo. Los pagos solo se habilitan mediante proveedores autorizados y controles específicos contra duplicidad y fraude.":
    "Función efecto jurídico, económico térã administrativo orekóva oguereko autenticación, permiso, constancia ha auditoría registro riesgo nivel rehe. Pago oñemoneĩ proveedor autorizado ha control duplicidad ha fraude rehegua rupive añoite.",
  "Arquitectura y seguridad": "Arquitectura ha seguridad",
  "La plataforma utiliza servicios de nube para entrega web, autenticación, base de datos y almacenamiento. La arquitectura separa los contenidos públicos de los módulos autenticados y aplica permisos por rol, políticas de acceso, registros de auditoría y protección de sesiones.":
    "Plataforma oiporu nube tembiaporã web ñeme'ẽ, autenticación, base de datos ha ñongaturã. Arquitectura omboja'o contenido público módulo autenticado-gui ha omoĩ permiso rol rehe, jeike política, auditoría registro ha sesión ñangareko.",
  "Las referencias internacionales de seguridad y privacidad orientan el diseño, entre ellas ISO/IEC 27001, ISO/IEC 27701 y buenas prácticas OWASP. Su mención no implica que la Municipalidad o el proveedor posean una certificación que no haya sido expresamente publicada y verificada.":
    "Seguridad ha ñemigua ñangareko referencia internacional ombohape diseño, umíva apytépe ISO/IEC 27001, ISO/IEC 27701 ha OWASP práctica porã. Oñembohéra haguére nde'iséi Tavao térã proveedor orekoha certificación noñemyasãi ha nojehechajeyiva.",
  "Calidad, auditoría y mejora continua": "Calidad, auditoría ha ñemyatyrõ tapia",
  "Los cambios relevantes se someten a controles técnicos, pruebas y revisión de permisos antes de publicarse. Las acciones administrativas sensibles deben quedar asociadas a una identidad, función, fecha y resultado para facilitar el control institucional.":
    "Ñemoambue tuicháva ohasa control técnico, prueba ha permiso jehechajey rupi oñemyasãi mboyve. Tembiapo administrativo sensible opyta va'erã identidad, función, arange ha resultado ndive, control institucional oñembohape hag̃ua.",
  "Los errores pueden reportarse por el canal de contacto. La corrección de un problema técnico no altera por sí sola el contenido ni la validez de un acto administrativo, que corresponde a la autoridad competente.":
    "Jejavy ikatu oñemomarandu contacto rape rupive. Apañuãi técnico ñemyatyrõ nomoambuéi ijehegui contenido térã acto administrativo validez, upéva mburuvicha ikatupyrývape oĩ.",
  "Marco institucional": "Mbojojaha institucional",
  "Piribebuy Digital se desarrolla dentro de las competencias municipales y del marco paraguayo sobre procedimientos administrativos, transparencia, documentos electrónicos, accesibilidad y protección de datos. Las políticas del portal se actualizan cuando cambia la normativa o se habilitan nuevas funciones.":
    "Piribebuy Digital oñemoheñói tavao competencia ha Paraguái procedimiento administrativo, transparencia, kuatia electrónica, jeikeporã ha dato ñangareko mbojojaha ryepýpe. Portal política oñembopyahu norma iñambue térã función pyahu oñemoneĩ jave.",
  "Contacto y participación": "Contacto ha participación",
  "Las observaciones sobre contenido, accesibilidad, privacidad, seguridad o funcionamiento pueden remitirse por el canal institucional. Para una solicitud formal debe utilizarse Mesa de Entrada y conservarse el número de expediente.":
    "Contenido, jeikeporã, ñemigua ñangareko, seguridad térã funcionamiento rehegua remiandu ikatu oñemondo canal institucional rupive. Jerure formal-pe ojeporu va'erã Mesa de Entrada ha oñeñongatu expediente número.",
  "Abrir una solicitud formal": "Ambohape peteĩ jerure formal",
  "Una plataforma municipal con responsabilidad pública":
    "Tavao plataforma responsabilidad pública reheve",
  "Propósito, gobernanza, alcance y criterios que orientan el desarrollo de Piribebuy Digital.":
    "Piribebuy Digital rembipota, ñesãmbyhy, ohupytyha ha criterio desarrollo ombohapéva.",
  "Proyecto institucional": "Proyecto institucional",
  "Información institucional verificada": "Marandu institucional ojehechajeyva",
  "Borrador recuperado.": "Hai pyre oñeguenohẽ jey.",
  "Los datos del formulario se conservaron en esta pestaña.":
    "Formulario marandu oñeñongatu ko tendayképe.",
  "Por seguridad del navegador, volvé a seleccionar el archivo de imagen.":
    "Navegador seguridad rehe, eiporavo jey ta'anga ñongatuha.",
};

export function translateToGuarani(value: string): string {
  const leading = value.match(/^\s*/)?.[0] ?? "";
  const trailing = value.match(/\s*$/)?.[0] ?? "";
  const source = value.trim();
  if (!source) return value;

  const direct = guaraniTranslations[source];
  if (direct) return `${leading}${direct}${trailing}`;

  const resultCount = source.match(/^(\d+) coincidencias?$/);
  if (resultCount) return `${leading}${resultCount[1]} ojejuhúva${trailing}`;

  const proceduresCount = source.match(/^(\d+) trámites encontrados$/);
  if (proceduresCount) {
    return `${leading}${proceduresCount[1]} tembiaporã ojejuhu${trailing}`;
  }

  const progress = source.match(/^Avance (\d+)%$/);
  if (progress) return `${leading}Mba'éichapa oho ${progress[1]}%${trailing}`;

  const receivedBy = source.match(/^Recibido por (.+)$/);
  if (receivedBy) return `${leading}Og̃uahẽ ${receivedBy[1]} pópe${trailing}`;

  const derivedBy = source.match(/^Derivado a (.+) por (.+)$/);
  if (derivedBy) {
    return `${leading}Oñembohasa ${derivedBy[1]}-pe ${derivedBy[2]} rupive${trailing}`;
  }

  const assignedBy = source.match(/^Asignado por (.+)$/);
  if (assignedBy) return `${leading}${assignedBy[1]} omoĩ${trailing}`;

  const linkedBy = source.match(/^Personal vinculado por (.+)$/);
  if (linkedBy) return `${leading}Mba'apohára ombojoaju ${linkedBy[1]}${trailing}`;

  const registeredBy = source.match(/^Registrado por (.+)$/);
  if (registeredBy) return `${leading}Oheja jehaipyre ${registeredBy[1]}${trailing}`;

  return value;
}

